<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>

                    <div class="button-group">
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/revisao-credito">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row
            v-if="dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6">
            <v-col>
                <v-banner single-line outlined>

                    <div class="d-flex justify-space-between align-center">
                        <div>
                            Esta divergência foi marcada como <span class="text-uppercase"> <strong>{{
                                dataset.data.status === 1
                                    ? 'aprovada'
                                    : (dataset.data.status === 2
                                        ? 'rejeitada'
                                        : (dataset.data.status === 3
                                            ? 'aprovada parcialmente'
                                            : ''
                                        )
                                    )
                            }}</strong>

                            </span> por
                            <span class="text-uppercase"> <strong>
                                    {{
                                        dataset.data.admin
                                            ? dataset.data.admin.name
                                            : dataset.data.analyzed_at !== "0000-00-00 00:00:00" && !dataset.data.admin
                                                ? "SISTEMA"
                                                : "N/A"
                                    }}
                                </strong></span>

                        </div>

                        <!-- <div class="icon-container">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon icon v-on="on" @click="statusReset()" size="large" class="border ">
                                        mdi-reload
                                    </v-icon>
                                </template>
<span>Restaurar pedido</span>
</v-tooltip>
</div> -->
                    </div>
                </v-banner>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm" v-if="dataset.data && dataset.data.user">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes credor</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled id="name" label="Nome completo"
                                                v-model="dataset.data.user.name" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled label="E-mail"
                                                v-model="dataset.data.user.email" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled label="CPF/CNPJ"
                                                v-model="dataset.data.user.registration" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field dense id="uuid" label="Classe"
                                                :value="dataset.data.creditor ? dataset.creditorTypes.find((x) => x.id == dataset.data.creditor.type).name : 'N/A'"
                                                outlined hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field dense id="uuid" label="Valor arrolado"
                                                :value="dataset.data.creditor ? 'R$ ' + parseFloat(dataset.data.creditor.amount).toFixed(2) : 'N/A'"
                                                outlined hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row v-if="dataset.data.lawyer">
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome procurador"
                                                v-model="dataset.data.lawyer.name" outlined hide-details="auto"
                                                disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="E-mail procurador"
                                                v-model="dataset.data.lawyer.email" outlined hide-details="auto"
                                                disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="OAB procurador"
                                                v-model="dataset.data.lawyer.federal_registration" outlined
                                                hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="UF procurador"
                                                v-model="dataset.data.lawyer.federal_registration_uf" outlined
                                                hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row class="mt-4" dense v-if="dataset && dataset.data && (dataset.data.user.url_document || (dataset.data.lawyer && (dataset.data.lawyer.url_document || dataset.data.lawyer.url_procuration)))
                                        && $check(user, ['objectionevents.update.files'])">
                                        <v-col cols="10">
                                            <v-row gutter="10">
                                                <v-col cols="2" sm="4" md="3" class="mr-5"
                                                    v-if="dataset && dataset.data && dataset.data.user && dataset.data.user.url_document">
                                                    <div class="document-container">
                                                        <a :href="dataset.data.user.url_document" target="_blank"
                                                            rel="noopener noreferrer" class="overlay-link">
                                                        </a>
                                                        <iframe :src="dataset.data.user.url_document"
                                                            class="document-frame rounded-xl"></iframe>
                                                    </div>
                                                    <div class="text-left caption-text">DOCUMENTO CREDOR</div>
                                                </v-col>
                                                <v-col cols="2" sm="4" md="3" class="mr-5"
                                                    v-if="dataset && dataset.data && dataset.data.lawyer && dataset.data.lawyer.url_document">
                                                    <div class="document-container">
                                                        <a :href="dataset.data.lawyer.url_document" target="_blank"
                                                            rel="noopener noreferrer" class="overlay-link">
                                                        </a>
                                                        <iframe :src="dataset.data.lawyer.url_document"
                                                            class="document-frame rounded-xl"></iframe>
                                                    </div>
                                                    <div class="text-left caption-text">DOCUMENTO PROCURADOR</div>
                                                </v-col>
                                                <v-col cols="2" sm="4" md="3" class="mr-5"
                                                    v-if="dataset && dataset.data && dataset.data.lawyer && dataset.data.lawyer.url_procuration">
                                                    <div class="document-container">
                                                        <a :href="dataset.data.lawyer.url_procuration" target="_blank"
                                                            rel="noopener noreferrer" class="overlay-link">
                                                        </a>
                                                        <iframe :src="dataset.data.lawyer.url_procuration"
                                                            class="document-frame rounded-xl"></iframe>
                                                    </div>
                                                    <div class="text-left caption-text">DOCUMENTO PROCURAÇÃO</div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row v-if="dataset.data && dataset.data.user">
            <v-col>
                <v-card outlined>
                    <v-card-text>
                        <v-row class="align-center">
                            <v-col cols="12" sm="6" class="d-flex align-center mt-n5">
                                <v-checkbox v-model="dataset.data.review_later" label="Sinalizar pedido" hide-details
                                    @change="saveReviewLater"
                                    :disabled="!$check(user, ['objectionevents.update.requests'])"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select dense :items="dataset.qgcRuleTypes" label="Regra"
                                    v-model="dataset.data.user_creditor_rule" item-value="id" item-text="name" outlined
                                    @change="saveSelectedRule(dataset.data)" hide-details="auto"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- <v-row v-if="dataset.data.status == 0">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Ações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-btn type="button" elevation="0" color="accent" class="mr-5"
                                    @click="updateStatus('approve')">Aprovar</v-btn>

                                <v-btn type="button" elevation="0" color="indigo darken-1" class="mr-5 white--text"
                                    @click="updateStatus('partial')">Aprovar Parcialmente</v-btn>

                                <v-btn type="button" elevation="0" color="error" class="mr-5"
                                    @click="updateStatus('reject')">Rejeitar</v-btn>

                                <v-btn type="button" elevation="0" color="#7E55AB" class="mr-5 white--text"
                                    @click.stop="openRequestDoc()">Solicitar Documento</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

        <v-row v-if="$check(user, ['objectionevents.update.contradictory'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Contraditórios</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense type="date" label="Prazo contraditório"
                                            :value="formatDate(dataset.data.contradictory_deadline_at)"
                                            @input="updateContraditory" outlined hide-details="auto"
                                            :disabled="!$check(user, ['objectionevents.update.contradictory'])">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-btn :loading="dataset.loading" type="button" elevation="0" color="primary"
                                            @click="updateContradictoryDeadline()"
                                            :disabled="!$check(user, ['objectionevents.update.contradictory'])">Salvar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-text>
                                <v-divider></v-divider>
                            </v-card-text>
                            <v-card-text>
                                <span v-if="!dataset.data.contradictory_reason">Nenhum contraditório encontrado</span>
                                <template v-else>
                                    <strong>Resultado: </strong> <v-chip small label class="mr-10"
                                        :color="getColorByStatus(dataset.data.contradictory_status)">
                                        {{ dataset.data.contradictory_status | enum(dataset.eventStatus, 'id',
                                            'name') }}
                                    </v-chip>
                                    <br />
                                    <strong>Enviado em: </strong>
                                    <span v-if="dataset.data.contradictory_status_at">{{
                                        dataset.data.contradictory_status_at | defaultDate('DD/MM/YYYY')
                                    }}</span>
                                    <br />
                                    <br />
                                    <strong>Valor indicado: </strong>
                                    <span v-if="dataset.data.contradictory_amount">
                                        {{ dataset.data.contradictory_amount | currency }}
                                    </span>
                                    <span v-else>N/A</span>
                                    <br />
                                    <br />
                                    <strong>Documentos: </strong>
                                    <template v-if="dataset.data.contradictory_docs">
                                        <br />
                                        <span v-for="(item, index) in resolveContradictoryDocs()" :key="index">
                                            - <a :href="item">{{ item }}</a><br />
                                        </span>
                                    </template>
                                    <span v-else>N/A</span>
                                    <br />
                                    <br />
                                    <strong>Motivo </strong>
                                    <br />
                                    <div v-html="dataset.data.contradictory_reason"></div>
                                </template>
                            </v-card-text>
                            <v-card-text v-if="dataset.data.contradictory_reason_file_url">
                                <v-btn type="button" elevation="0" color="primary" outlined
                                    :href="dataset.data.contradictory_reason_file_url" target="_blank">Visualizar
                                    documento
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="$check(user, ['objectionevents.update.process'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Processos</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <template v-if="dataset.data && dataset.data.processes.length > 0">
                            <v-expansion-panels>
                                <v-expansion-panel v-for="(process) in dataset.data.processes" :key="process.id">
                                    <v-expansion-panel-header>
                                        <div class="d-flex align-center">
                                            <strong>Número: </strong>
                                            <span class="ml-2 mr-2">
                                                {{ process.number }}
                                            </span>
                                            <v-spacer></v-spacer>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon @click="copyToClipboard(process.number)"
                                                        :disabled="!$check(user, ['objectionevents.update.process'])"
                                                        v-bind="attrs" v-on="on">
                                                        mdi-content-copy
                                                    </v-icon>
                                                </template>
                                                <span>Copiar número do processo</span>
                                            </v-tooltip>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <p><strong>Local:</strong> {{ process.local }}</p>
                                        <p><strong>Tribunal:</strong> {{ process.court }}</p>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </template>
                        <template v-else>
                            <v-row>
                                <v-col>
                                    <span>Nenhum processo encontrado</span>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Relatórios</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text v-if="dataset.loadingReport">
                        <v-progress-circular indeterminate color="primary" size="64" width="4"></v-progress-circular>
                    </v-card-text>
                    <v-card-text v-if="!dataset.loadingReport && dataset.reports && dataset.reports.length">
                        <v-row v-for="(item, index) in dataset.reports" :key="index">
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Modelo: </strong> {{ item.type.name || 'n/a' }}
                                        <br />
                                        <strong>Arquivo: </strong> {{ item.file.name || 'n/a' }}
                                        <br />
                                        <strong>Caso: </strong> {{ item.file.client.name || 'n/a' }}
                                        <br />
                                        <span v-for="(valueItem, index) in item.values" :key="index">
                                            <strong>{{ valueItem.column.label }}: </strong> {{ valueItem.value || 'n/a'
                                            }}
                                            <br />
                                        </span>
                                        <br />
                                        <v-divider v-if="index + 1 !== dataset.reports.length"></v-divider>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="!dataset.loadingReport && !dataset.reports.length">
                        <v-row>
                            <v-col cols="12">
                                Nenhum relatório encontrado
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

      <!-- Dados credor QGC Ajustado -->
        <v-row v-if="dataset && dataset.data && dataset.data.qgcItems && dataset.data.qgcItems.length">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Dados QGC Ajustado</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CPF/CNPJ</th>
                                        <th>Classe</th>
                                        <th>Valor</th>
                                        <th class="text-center">Solicitação anterior</th>
                                        <th class="text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(qgcItem, qgcIndex) in dataset.data.qgcItems" :key="qgcIndex">
                                        <td>{{ qgcItem.name || 'N/A' }}</td>
                                        <td>{{ formatRegistration(qgcItem.registration) || 'N/A' }}</td>
                                        <td>{{ getCreditorTypeName(qgcItem.type) }}</td>
                                        <td>R$ {{ qgcItem.amount | currency }}</td>
                                        <td class="text-center">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-chip
                                                        v-on="on"
                                                        x-small
                                                        label
                                                        :color="qgcItem.action_type != null ? 'orange darken-1' : 'grey lighten-1'"
                                                        :class="qgcItem.action_type != null ? 'white--text' : ''"
                                                        :style="qgcItem.action_type != null ? 'cursor:pointer' : 'cursor:default'"
                                                        @click="qgcItem.action_type != null ? openQgcActionInfo(qgcItem) : null"
                                                    >
                                                        <v-icon x-small left>
                                                            {{ qgcItem.action_type != null ? 'mdi-clipboard-clock-outline' : 'mdi-clipboard-check-outline' }}
                                                        </v-icon>
                                                        {{ qgcItem.action_type != null ? 'Sim' : 'Não' }}
                                                    </v-chip>
                                                </template>
                                                <span v-if="qgcItem.action_type == null">Nenhuma solicitação anterior registrada</span>
                                                <span v-else>Existe uma solicitação de alteração — clique para ver detalhes</span>
                                            </v-tooltip>
                                        </td>
                                        <td class="text-center">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        v-on="on"
                                                        x-small
                                                        color="primary"
                                                        outlined
                                                        @click="openQgcActionModal(qgcItem)"
                                                    >
                                                        <v-icon x-small left>mdi-pencil</v-icon>
                                                        Alterar
                                                    </v-btn>
                                                </template>
                                                <span>Solicitar alteração no QGC para este credor</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Habilitação / Divergência -->
        <v-row v-if="dataset.data.userEvent && dataset.data.userEvent.length">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Habilitação / Divergência</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>

                                        <strong>Devedora: </strong> <span>{{ dataset.data.userEvent[0].client ?
                                            dataset.data.userEvent[0].client.name
                                            : '' }}</span>
                                        <br />
                                        <strong>Solicitado em: </strong>
                                        <span>{{
                                            dataset.data.userEvent[0].created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                        }}</span>
                                        <br />
                                        <br>
                                        <span><strong>NEGÓCIO(S)</strong></span>
                                        <br />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-expansion-panels>
                                            <v-expansion-panel
                                                v-for="(eventItem, eventIndex) in dataset.data.userEvent[0].items"
                                                :key="eventIndex">
                                                <v-expansion-panel-header>
                                                    <div>
                                                        <strong>Origem:</strong>
                                                        <span>
                                                            {{
                                                                truncateText(
                                                                    eventItem.origin,
                                                                    30
                                                                )
                                                            }}
                                                        </span>
                                                        /
                                                        <strong>Valor:</strong>
                                                        <span v-if="eventItem.amount">
                                                            {{
                                                                eventItem.currency | enum(
                                                                    dataset.currencyTypes,
                                                                    'id',
                                                                    'currencyFormat'
                                                                )
                                                            }}
                                                            {{ eventItem.amount | currency }}
                                                        </span>
                                                        <span v-else>N/A</span>
                                                    </div>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-row>
                                                        <v-col>
                                                            <p>
                                                                <span class="section-info-title">Devedora</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ dataset.data.client.name }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Origem</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.origin }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Moeda</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{
                                                                        eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'name'
                                                                        )
                                                                    }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Valor</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">{{
                                                                    eventItem.currency
                                                                    | enum(
                                                                        dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat'
                                                                    )
                                                                    }}
                                                                    {{
                                                                        eventItem.amount | currency
                                                                    }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Número pedido</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.request_number }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Motivo</span>
                                                                <br />
                                                                <span class="section-info-value"
                                                                    v-html="getTruncatedReason(eventItem.reason)"></span>
                                                                <v-btn
                                                                    v-if="eventItem.reason && stripHtml(eventItem.reason).length > 150"
                                                                    text small color="primary" @click="toggleReason"
                                                                    class="ml-2">
                                                                    {{ isReasonExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
                                                                </v-btn>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Observações</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.observation }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Documentos</span>
                                                                <br />
                                                                <span class="section-info-value">{{
                                                                    eventItem.docs.length
                                                                }}
                                                                    arquivo(s)</span>
                                                            </p>

                                                            <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                            <br>
                                                            <v-row
                                                                v-for="category in getEventItemsByCategory(eventItem)"
                                                                :key="category.id">
                                                                <v-col cols="12">
                                                                    <h3>{{ category.name }}</h3>
                                                                    <br>
                                                                    <v-row>
                                                                        <v-col v-for="doc in category.docs"
                                                                            :key="doc.id" cols="auto">
                                                                            <v-img @click="openDoc(doc.file_url)"
                                                                                class="rounded-xl"
                                                                                lazy-src="https://picsum.photos/id/11/10/6"
                                                                                :height="100" :width="100"
                                                                                :src="doc.file_url"></v-img>
                                                                            {{ doc.name }}
                                                                            <br>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn small color="primary" @click="viewUserEvent(dataset.data.userEvent)">
                                    Ver detalhes
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- EM REVISÂO -->
        <v-row v-if="dataset.data.currentReview && $check(user, ['objectionevents.view.review'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Revisão</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Resultado: </strong> <span>{{ dataset.data.currentReview.status |
                                            enum(dataset.eventStatus, 'id', 'name') }}</span>
                                        <br />
                                        <strong>Revisado em: </strong>
                                        <span v-if="dataset.data.currentReview.reviewed_at">{{
                                            dataset.data.currentReview.reviewed_at | defaultDate('DD/MM/YYYY')
                                        }}</span>
                                        <span v-else>N/A</span>
                                        <br />
                                        <strong>Revisado por: </strong>
                                        <span>{{
                                            dataset.data.currentReview.reviewed_by ?
                                                dataset.data.currentReview.admin.name :
                                                'N/A'
                                        }}</span>
                                        <br />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Revisão Crédito - BLOCO 1 -->
        <v-row v-if="dataset && dataset.data && dataset.data.debtorData && dataset.data.debtorData.length > 0">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">
                                    Revisão -
                                    {{ dataset.data.debtorData && dataset.data.debtorData[0] &&
                                        dataset.data.debtorData[0].type
                                        === 4
                                        ? 'DEVEDORA'
                                    : 'CREDOR'
                                    }}
                                </span>

                                <v-btn v-if="dataset.data.debtorData && dataset.data.debtorData.length" type="button"
                                    class="ml-2" small elevation="0" color="primary"
                                    @click="viewObjectionEventDetails(dataset.data.debtorData[0])">
                                    ir para o pedido
                                </v-btn>

                                <!-- <v-chip
                                    small class="text-uppercase font-weight-bold text-caption ml-2"
                                    :color="typeChip.color" label text-color="white"
                                >
                                    {{ typeChip.label }}
                                </v-chip> -->

                            </div>
                            <!-- <v-col cols="3">
                                <v-progress-linear :value="dataset.loading ? undefined : progress" color="green"
                                    height="20" rounded :indeterminate="dataset.loading">
                                    <strong v-if="!dataset.loading" class="centered">{{ progress }}% analisados</strong>
                                    <span v-else class="centered">Carregando...</span>
                                </v-progress-linear>

                            </v-col> -->
                        </div>

                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <!-- <strong>Revisão de Crédito</strong>
                                        <br /> -->
                                        <strong>Devedora: </strong> <span>{{ dataset.data.debtorData[0].client ?
                                            dataset.data.debtorData[0].client.name
                                            : '' }}</span>
                                        <br />
                                        <strong>Solicitado em: </strong>
                                        <span>{{
                                            dataset.data.debtorData[0].created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                        }}</span>
                                        <br />
                                        <!--
                                        <v-row>
                                            <v-col cols="3">
                                                <strong>Total de casos analisados: </strong>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-progress-linear :value="progress" color="green" height="20"
                                                    class="mb-3" rounded>
                                                    <strong>{{ progress }}%</strong>
                                                </v-progress-linear>
                                            </v-col>
                                        </v-row>
                                        --->

                                    </v-col>
                                </v-row>
                                <v-row v-if="!dataset.loading && dataset.data.debtorData && dataset.data.debtorData.length">
                                    <v-col>
                                        <strong>Resultado: </strong>
                                        <v-chip small label class="mr-10"
                                            :color="getColorByStatus(getFinalStatus(dataset.data.debtorData[0].items))">
                                            {{ getFinalStatus(dataset.data.debtorData[0].items) |
                                                enum(dataset.eventStatus, 'id',
                                                    'name') }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="dataset.data.debtorData && dataset.data.debtorData.length && dataset.data.debtorData[0].type === 4">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-bold mt-4">Decisão do credor: </span>
                                          <v-chip
                                            :color="creditorDecisionStatus(dataset.data.debtorData[0].creditor_decision).color"
                                            class="white--text" label small>
                                            {{ creditorDecisionStatus(dataset.data.debtorData[0].creditor_decision).text }}
                                        </v-chip>

                                        <br/>
                                        <strong>Decidido em: </strong>
                                        <span>
                                            {{ dataset.data.debtorData[0].creditor_decision_at && dataset.data.debtorData[0].creditor_decision_at !== '0000-00-00 00:00:00'
                                                ? $moment(dataset.data.debtorData[0].creditor_decision_at).format('DD/MM/YYYY HH:mm:ss')
                                                : 'Pendente' }}
                                        </span>
                                        <br/>
                                        <br/>
                                        <strong>Motivo da decisão </strong>
                                        <br/>
                                        
                                        <span>{{ dataset.data.debtorData[0].creditor_decision_reason || 'N/A' }}</span>
                                        
                                        <br/>
                                      
                                    </v-col>
                                    <v-col cols="12">
                                    </v-col>
                                </v-row>
                                <v-row v-if="!dataset.loading && dataset.data.debtorData && dataset.data.debtorData.length && (!dataset.data.debtorData[0].currentReview || dataset.data.debtorData[0].currentReview.status !== 0)">
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="#B39DDB" class="mr-5" small
                                            v-if="(dataset.data.debtorData[0].status && dataset.data.debtorData[0].status !== 4 && dataset.data.debtorData[0].status !== 5 && dataset.data.debtorData[0].status !== 6 && dataset.data.debtorData[0].status !== 7)
                                                || !$check(user, ['objectionevents.restore'])"
                                            @click="statusReset(dataset.data.debtorData[0])">Restaurar</v-btn>

                                        <v-btn type="button" elevation="0" color="accent" class="mr-5" small
                                            :disabled="(dataset.data.debtorData[0].status !== 0 && dataset.data.debtorData[0].status !== 4 && dataset.data.debtorData[0].status !== 5 && dataset.data.debtorData[0].status !== 6 && dataset.data.debtorData[0].status !== 7) || !getFinalStatus(dataset.data.debtorData[0].items)"
                                            @click="updateStatus(dataset.data.debtorData[0])">Confirmar</v-btn>

                                        <v-btn type="button" elevation="0" color="#FF8F00" small
                                            :disabled="(dataset.data.debtorData[0].status !== 0 && dataset.data.debtorData[0].status !== 4 && dataset.data.debtorData[0].status !== 5 && dataset.data.debtorData[0].status !== 6 && dataset.data.debtorData[0].status !== 7)
                                                || !$check(user, ['objectionevents.update.eventitem.review'])"
                                            @click="createReview(dataset.data.debtorData[0])" class="mr-5">Enviar
                                            para revisão</v-btn>

                                        <v-btn type="button" elevation="0" color="#7E55AB" class="mr-5 white--text"
                                            small :disabled="(dataset.data.debtorData[0].status !== 0 && dataset.data.debtorData[0].status !== 4 && dataset.data.debtorData[0].status !== 5 && dataset.data.debtorData[0].status !== 6 && dataset.data.debtorData[0].status !== 7)
                                                || !$check(user, ['objectionevents.update.eventitem.docs'])"
                                            @click.stop="openRequestDoc(dataset.data.debtorData[0])">Solicitar
                                            Documento</v-btn>

                                        <v-btn type="button" elevation="0" color="primary" class="mr-5 white--text"
                                            small :disabled="(dataset.data.debtorData[0].status !== 0 && dataset.data.debtorData[0].status !== 4 && dataset.data.debtorData[0].status !== 5 && dataset.data.debtorData[0].status !== 6 && dataset.data.debtorData[0].status !== 7)
                                                || !$check(user, ['objectionevents.create.eventitem'])"
                                            @click.stop="openCreateBusinessModal(dataset.data.debtorData[0])">Adicionar
                                            Negócio</v-btn>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <span><strong>NEGÓCIO(S)</strong></span>
                                    </v-col>
                                </v-row>

                                <v-row v-if="!dataset.loading && dataset.data.debtorData && dataset.data.debtorData.length && dataset.data.debtorData[0].currentReview && $check(user, ['objectionevents.update.eventitem.action'])">
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="accent"
                                                    class="mr-5" small @click="updateReview(dataset.data.debtorData[0], 1)">Aprovar</v-btn>
                                            </template>
                                            <span>Clique no botão para aprovar o negócio.</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="error" class="mr-5"
                                                    small @click="updateReview(dataset.data.debtorData[0], 2)">Rejeitar</v-btn>
                                            </template>
                                            <span>Clique no botão para rejeitar o negócio.</span>
                                        </v-tooltip>

                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div>
                                            <div v-if="dataset.loading" class="loading-container">
                                                <v-progress-circular indeterminate color="green" size="50"
                                                    class="my-5"></v-progress-circular>
                                                <span>Carregando...</span>
                                            </div>
                                            <v-expansion-panels v-else>

                                                <v-expansion-panel
                                                    v-for="(eventItem, eventIndex) in dataset.data.debtorData[0].items"
                                                    :key="eventIndex">

                                                    <v-expansion-panel-header @click.stop>
                                                        <div class="d-flex align-center">
                                                            <div>
                                                                <strong>ID: </strong>
                                                                <span class="ml-2 mr-2">#{{ eventItem.id }}</span> /
                                                                <strong>Origem: </strong>
                                                                <span class="ml-2 mr-2">{{ truncateText(eventItem.origin
                                                                    ||
                                                                    'N/A', 30) }}</span> /
                                                                <strong class="ml-2">Valor: </strong>
                                                                <span class="ml-2" v-if="eventItem.amount">
                                                                    {{ eventItem.currency | enum(dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat') }}
                                                                    {{ eventItem.amount | currency }}
                                                                </span>
                                                                <span v-else>N/A</span>
                                                            </div>

                                                            <v-spacer></v-spacer>

                                                            <v-chip label class="mr-10" small
                                                                :color="getColorByStatus(eventItem.status, eventItem.proposal_status)"
                                                                style="color: white">
                                                                {{ eventItem.status | enum(dataset.eventStatus, 'id',
                                                                    'name') }}
                                                            </v-chip>

                                                            <v-chip v-if="eventItem.contradictory_status === 3" label
                                                                small :color="getCounterProposalColor(eventItem)"
                                                                class="mr-4 white--text">
                                                                {{ getCounterProposalLabel(eventItem) }}
                                                            </v-chip>

                                                            <template v-if="!eventItem.isEditing">
                                                                <v-tooltip bottom :disabled="!eventItem.status">
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 0)"
                                                                            :disabled="eventItem.status === 0 || eventItem.status === 4 || eventItem.status === 5
                                                                                || !$check(user, ['objectionevents.restore'])"
                                                                            size="large">
                                                                            <v-icon>mdi-refresh-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para restaurar o status do
                                                                        negócio</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, eventItem.partial_amount ? 3 : 1)"
                                                                            size="large" :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4 
                                                                                || !$check(user, ['objectionevents.action'])"
                                                                            :color="eventItem.partial_amount ? '#FF8F00' : 'green'">
                                                                            <v-icon>mdi-check-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span v-if="!eventItem.partial_amount">
                                                                        Clique no botão para aprovar este negócio.
                                                                       
                                                                    </span>
                                                                    <span v-else>
                                                                        Clique no botão para aprovar parcialmente este negócio.
                                                                    </span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 2)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !$check(user, ['objectionevents.action'])"
                                                                            size="large" color="red">
                                                                            <v-icon>mdi-close-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para rejeitar este negócio.</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="editItem(eventItem, eventIndex)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !$check(user, ['objectionevents.update.eventitem'])"
                                                                            size="large" color="primary" class="me-2">
                                                                            <v-icon>mdi-pencil-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para habilitar a edição dos
                                                                        campos deste
                                                                        negócio e atualizar as informações conforme
                                                                        necessário.</span>
                                                                </v-tooltip>
                                                            </template>

                                                            <div v-if="eventItem.isEditing"
                                                                class="button-group ml-auto mr-10">
                                                                <v-btn
                                                                    :disabled="!$check(user, ['objectionevents.update.eventitem'])"
                                                                    @click.stop="saveEdit(eventItem)" small
                                                                    elevation="0" color="primary">
                                                                    Salvar
                                                                </v-btn>
                                                                <v-btn @click.stop="cancelEditItem(eventItem)" small
                                                                    elevation="0" color="error">
                                                                    Cancelar
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </v-expansion-panel-header>

                                                    <v-expansion-panel-content>
                                                        <v-row>
                                                            <v-col>
                                                                <p>
                                                                    <span class="section-info-title">Devedora</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="4">
                                                                                <v-autocomplete dense
                                                                                    :items="dataset.clients"
                                                                                    v-model="eventItem.company_name"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto"
                                                                                    required :rules="[$rules.required]"
                                                                                    no-data-text="Nenhuma devedora encontrada"></v-autocomplete>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{ eventItem.company_name }}
                                                                        </span>
                                                                    </template>
                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Origem</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="4">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="origin"
                                                                                    :items="dataset.creditorOriginTypes"
                                                                                    label="Selecione a origem"
                                                                                    v-model="eventItem.origin"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{ eventItem.origin }}</span>
                                                                    </template>
                                                                </p>

                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <span class="section-info-title">Classe</span>
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-autocomplete dense
                                                                                :items="dataset.creditorTypes"
                                                                                v-model="eventItem.type" item-value="id"
                                                                                item-text="name" outlined
                                                                                hide-details="auto" required
                                                                                :rules="[$rules.required]"
                                                                                no-data-text="Nenhuma classe encontrada"
                                                                                @change="onAutocompleteChange(eventIndex)"
                                                                                :disabled="!$check(user, ['objectionevents.update.eventitem'])"></v-autocomplete>
                                                                        </template>
                                                                        <template v-else>
                                                                            <br />
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    getCreditorTypeName(eventItem.type)
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </v-col>
                                                                </v-row>

                                                                <br />
                                                                <p>
                                                                    <span class="section-info-title">Moeda</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="4">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="type"
                                                                                    :items="dataset.currencyTypes"
                                                                                    label="Selecione uma moeda"
                                                                                    v-model="eventItem.currency"
                                                                                    item-value="id" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{
                                                                                eventItem.currency
                                                                                | enum(
                                                                                    dataset.currencyTypes,
                                                                                    'id',
                                                                                    'name'
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </template>
                                                                </p>

                                                                <template>
                                                                    <p>
                                                                        <span class="section-info-title">Valor indicado
                                                                            {{ dataset.data.debtorData && dataset.data.debtorData[0] &&
                                                                                dataset.data.debtorData[0].type === 4
                                                                                    ? 'pela devedora'
                                                                                    : 'pelo credor'
                                                                            }}
                                                                        </span>
                                                                        <br />
                                                                        <template>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                enum(dataset.currencyTypes, 'id',
                                                                                    'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.amount | currency }}
                                                                            </span>
                                                                        </template>
                                                                    </p>
                                                                    <p>
                                                                        <span class="section-info-title">Valor definido
                                                                            pelo
                                                                            AJ</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="4">
                                                                                    <v-currency-field
                                                                                        :disabled="dataset.loading && !$check(user, ['objectionevents.update.eventitem'])"
                                                                                        label="Valor" dense
                                                                                        aria-label="Digite o valor"
                                                                                        v-model="editedPartialAmount"
                                                                                        :allowNegative="false"
                                                                                        hide-details="auto" outlined>
                                                                                    </v-currency-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                enum(dataset.currencyTypes, 'id',
                                                                                    'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.partial_amount | currency
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </p>
                                                                    <p>
                                                                        <span class="section-info-title">Número
                                                                            pedido</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="4">
                                                                                    <v-text-field
                                                                                        v-model="editedRequestNumber"
                                                                                        outlined dense
                                                                                        hide-details="auto"
                                                                                        :disabled="!$check(user, ['objectionevents.update.eventitem'])">
                                                                                    </v-text-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    eventItem.request_number &&
                                                                                        eventItem.request_number !== 'undefined'
                                                                                        ? eventItem.request_number
                                                                                        : 'N/A'
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </p>

                                                                </template>


                                                                <p>
                                                                    <span class="section-info-title">Observações</span>
                                                                    <br />
                                                                    <span class="section-info-value text-uppercase">
                                                                        {{ eventItem.observation ?
                                                                            eventItem.observation
                                                                            : 'Não há observações registradas' }}</span>
                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Motivo</span>
                                                                    <br />

                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="12">
                                                                                <tiptap-vuetify
                                                                                    class="custom-editor-short"
                                                                                    v-model="editedReason"
                                                                                    :rules="[$rules.required]"
                                                                                    :extensions="extensions"
                                                                                    hide-details="auto" />
                                                                                <v-tooltip bottom>
                                                                                    <template #activator="{ on }">
                                                                                        <v-icon v-on="on"
                                                                                            @click="openDialogDynamicText('editedReason')"
                                                                                            class="me-2">
                                                                                            mdi-text-long
                                                                                        </v-icon>
                                                                                    </template>
                                                                                    <span>Selecionar textos longos
                                                                                        predefinidos</span>
                                                                                </v-tooltip>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-if="!eventItem.reason"
                                                                            class="section-info-value text-uppercase">
                                                                            Não há motivos registrados
                                                                        </span>
                                                                        <div v-else v-html="eventItem.reason"></div>
                                                                    </template>


                                                                </p>
                                                                <p>
                                                                    <span class="section-info-title"
                                                                        color="red">Contraditório</span>
                                                                    <br />
                                                                    <template v-if="eventItem.contradictory_reason">
                                                                        <v-chip small label class="mr-10 mt-4"
                                                                            :color="getColorByStatus(eventItem.contradictory_status)">
                                                                            {{ eventItem.contradictory_status |
                                                                            enum(dataset.eventStatus, 'id',
                                                                                'name') }}
                                                                        </v-chip>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Valor indicado: </strong>
                                                                        <span v-if="eventItem.contradictory_amount">
                                                                            {{ eventItem.contradictory_amount |
                                                                                currency }}
                                                                        </span>
                                                                        <span v-else>N/A</span>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Documentos: </strong>
                                                                        <template v-if="eventItem.contradictory_docs">
                                                                            <br />
                                                                            <span
                                                                                v-for="(item, index) in resolveContradictoryDocs()"
                                                                                :key="index">
                                                                                - <a :href="item">{{ item }}</a><br />
                                                                            </span>
                                                                        </template>
                                                                        <span v-else>N/A</span>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Motivo </strong>
                                                                        <br />
                                                                        <div v-html="eventItem.contradictory_reason">
                                                                        </div>
                                                                    </template>
                                                                </p>

                                                                <!-- BLOCO: Decisão do credor sobre a contraproposta (dentro do negócio) -->
                                                                <div v-if="eventItem.contradictory_status == 3"
                                                                    class="mt-4">
                                                                    <v-divider class="mb-3"></v-divider>
                                                                    <h4 class="mb-2">Decisão do credor sobre a
                                                                        contraproposta</h4>
                                                                    <v-row>
                                                                        <v-col cols="12"
                                                                            class="d-flex align-center mb-2">
                                                                            <span><strong>Status:</strong></span>
                                                                            <v-chip small class="ml-2 white--text"
                                                                                :color="eventItem.contradictory_creditor_decision === 1 ? 'green' : eventItem.contradictory_creditor_decision === 2 ? 'red' : 'grey'">
                                                                                {{
                                                                                    eventItem.contradictory_creditor_decision
                                                                                        === 1 ?
                                                                                        'Aprovado' :
                                                                                eventItem.contradictory_creditor_decision
                                                                                === 2 ?
                                                                                'Rejeitado' : 'Pendente'
                                                                                }}
                                                                            </v-chip>
                                                                        </v-col>
                                                                        <v-col cols="12"
                                                                            class="d-flex align-center mb-2">
                                                                            <span><strong>Data da
                                                                                    decisão:</strong></span>
                                                                            <span class="ml-2">
                                                                                {{
                                                                                    eventItem.contradictory_creditor_decision_at
                                                                                        &&
                                                                                        eventItem.contradictory_creditor_decision_at
                                                                                !==
                                                                                '0000-00-00 00:00:00' ? $moment(eventItem.contradictory_creditor_decision_at).format('DD/MM/YYYY HH:mm:ss') : 'N/A' }}
                                                                            </span>
                                                                        </v-col>

                                                                        <v-col cols="12"
                                                                            class="d-flex align-center mb-2">
                                                                            <span><strong>Valor:</strong></span>
                                                                            <span class="ml-2">
                                                                                {{ eventItem.contradictory_amount ? (eventItem.contradictory_amount | currency ): 'N/A' }}
                                                                            </span>
                                                                        </v-col>
                                                                    </v-row>
                                                                </div>

                                                                <!-- <p>
                                                                    <span class="section-info-title">Documentos</span>
                                                                    <br />
                                                                    <span class="section-info-value">{{
                                                                        eventItem.docs.length
                                                                        }}
                                                                        arquivo(s)</span>
                                                                </p> -->
                                                                <!-- <v-row>
                                                                <v-col v-for="(docItem, docIndex ) in eventItem.docs" :key="docIndex">
                                                                    <v-img @click="openDoc(docItem.doc.file_url)"
                                                                        class="rounded-xl"
                                                                        lazy-src="https://picsum.photos/id/11/10/6"
                                                                        :height="100" :width="100"
                                                                        :src="docItem.doc.file_url"></v-img>
                                                                </v-col>
                                                            </v-row> -->
                                                                <p>
                                                                    <span class="section-info-title">Documentos</span>
                                                                    <br />

                                                                    <!-- LINKS EXTERNOS -->
                                                                    <span v-if="hasExternalDocuments(eventItem)"
                                                                        class="section-info-value">
                                                                        {{ parsedDebtorDocuments(eventItem).length }}
                                                                        arquivo(s)
                                                                    </span>

                                                                    <!-- DOCUMENTOS INTERNOS -->
                                                                    <span v-else class="section-info-value">
                                                                        {{ eventItem.docs.length || 0 }} arquivo(s)
                                                                    </span>
                                                                </p>

                                                                <v-row v-if="hasExternalDocuments(eventItem)">
                                                                    <v-col
                                                                        v-for="(doc, index) in parsedDebtorDocuments(eventItem)"
                                                                        :key="index" cols="12">
                                                                        <v-icon small class="mr-2">mdi-link</v-icon>

                                                                        <a :href="doc" target="_blank" rel="noopener"
                                                                            class="text-decoration-underline">
                                                                            Documento {{ index + 1 }}
                                                                        </a>
                                                                    </v-col>
                                                                </v-row>


                                                                <!-- DOCUMENTOS PADRÃO -->
                                                                <template v-else>
                                                                    <v-divider
                                                                        v-if="eventItem.docs && eventItem.docs.length"></v-divider>
                                                                    <br>

                                                                    <v-row
                                                                        v-for="category in getEventItemsByCategory(eventItem)"
                                                                        :key="category.id">
                                                                        <v-col cols="12">
                                                                            <h3>{{ category.name }}</h3>
                                                                            <br>

                                                                            <v-row>
                                                                                <v-col v-for="doc in category.docs"
                                                                                    :key="doc.id" cols="auto">
                                                                                    <v-img
                                                                                        @click="openDoc(doc.file_url)"
                                                                                        :class="[
                                                                                            'rounded-xl',
                                                                                            verifyIsRequestedDoc(doc)
                                                                                                ? 'doc-active-class'
                                                                                                : 'doc-inactive-class'
                                                                                        ]" lazy-src="https://picsum.photos/id/11/10/6"
                                                                                        :height="100" :width="100"
                                                                                        :src="doc.file_url" />
                                                                                    {{ doc.name }}
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-col>
                                                                    </v-row>
                                                                </template>

                                                                <!-- <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                                <br>
                                                                <v-row
                                                                    v-for="category in getEventItemsByCategory(eventItem)"
                                                                    :key="category.id">
                                                                    <v-col cols="12">
                                                                        <h3>{{ category.name }}</h3>
                                                                        <br>
                                                                        <v-row>
                                                                            <v-col v-for="doc in category.docs"
                                                                                :key="doc.id" cols="auto">
                                                                                <v-img @click="openDoc(doc.file_url)"
                                                                                    :class="['rounded-xl', verifyIsRequestedDoc(doc) ? 'doc-active-class' : 'doc-inactive-class']"
                                                                                    lazy-src="https://picsum.photos/id/11/10/6"
                                                                                    :height="100" :width="100"
                                                                                    :src="doc.file_url">
                                                                                </v-img>
                                                                                {{ doc.name }}
                                                                                <br>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row> -->
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-col>
                                </v-row>
                                <!-- <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row> -->
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="dataset.qgcRuleTypes && dataset.qgcRuleTypes.length && dataset.data.debtorData && dataset.data.debtorData.length">
                            <v-col cols="12" md="6">
                                <p class="font-weight-bold mt-4">Regra</p>
                                <v-select dense outlined hide-details="auto"
                                    :items="dataset.qgcRuleTypes"
                                    item-value="id"
                                    item-text="name"
                                    :disabled="!$check(user, ['objectionevents.update.requests'])"
                                    v-model="dataset.data.debtorData[0].user_creditor_rule"
                                    @change="saveSelectedRule(dataset.data.debtorData[0])">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="$check(user, ['objectionevents.view.reason']) && dataset.data.debtorData && dataset.data.debtorData.length">
                            <v-col cols="12">
                                <p class="font-weight-bold mt-4">Motivo longo</p>
                                <tiptap-vuetify class="custom-editor-long"
                                    :disabled="(dataset.data.debtorData[0].status == 1 || dataset.data.debtorData[0].status == 2 || dataset.data.debtorData[0].status == 3)
                                        && !$check(user, ['objectionevents.update.reason'])"
                                    v-model="dataset.data.debtorData[0].reason"
                                    :extensions="extensions" :rules="[$rules.required]"
                                    hide-details="auto" />
                                <div class="char-counter">
                                    <span
                                        :class="{ 'text-red': getReasonLength(dataset.data.debtorData[0]) >= (dataset.reasonMaxChars - 10) }">
                                        {{ getReasonLength(dataset.data.debtorData[0]) }} / {{
                                            dataset.reasonMaxChars }}
                                    </span>
                                </div>
                                <v-alert v-if="isReasonExceeded(dataset.data.debtorData[0])" type="error"
                                    dense>
                                    O texto excede o limite máximo de {{ dataset.reasonMaxChars }} caracteres.
                                </v-alert>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon v-on="on" @click="openDialogDynamicText('debtorReason')"
                                            class="me-2">
                                            mdi-text-long
                                        </v-icon>
                                    </template>
                                    <span>Selecionar textos longos predefinidos</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row
                            v-if="$check(user, ['objectionevents.update.reason']) && dataset.data.debtorData && dataset.data.debtorData.length">
                            <v-col>
                                <v-btn type="button" elevation="0" color="primary"
                                    @click="saveReason(dataset.data.debtorData[0])">
                                    Salvar motivo
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="!dataset.loading && dataset.data.proposal_amount > 0 && dataset.data.proposal_at !== '0000-00-00 00:00:00'"
                            class="mt-4">
                            <v-col cols="12">
                                <v-card flat outlined class="pa-4" style="background-color: #f9f9f9;">
                                    <h3 class="mb-4">Contraproposta</h3>

                                    <v-card class="mb-4 pa-3" flat outlined style="border: 2px solid #78909C;">
                                        <v-row>
                                            <v-col cols="12" class="d-flex align-center mb-n5">
                                                <span>
                                                    <strong>Data de envio:</strong>
                                                    {{ dataset.data.proposal_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}
                                                </span>
                                            </v-col>
                                            <v-col cols="12" class="mb-n5">
                                                <span><strong>Validade:</strong> {{ dataset.data.proposal_deadline_at |
                                                    defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                            </v-col>
                                            <v-col cols="12">
                                                <span><strong>Valor proposto:</strong> R$ {{
                                                    dataset.data.proposal_amount | currency }}</span>
                                            </v-col>
                                            <v-col cols="12" v-if="dataset.data.proposal_doc_url">
                                                <v-tooltip bottom>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn color="primary" outlined small
                                                            :href="dataset.data.proposal_doc_url" target="_blank"
                                                            v-bind="attrs" v-on="on">
                                                            Visualizar documento
                                                        </v-btn>
                                                    </template>
                                                    <span>Visualizar documento da contraproposta</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="dataset.data.proposal_status !== 0 && dataset.data.proposal_creditor_at !== '0000-00-00 00:00:00'"
                                        class="mb-4 pa-3" flat outlined :style="`border: 2px solid ${dataset.data.proposal_status === 1 ? '#4CAF50' :
                                                dataset.data.proposal_status === 2 ? '#F44336' : '#9E9E9E'
                                            };`">
                                        <h4 class="mb-2">Resposta credor:</h4>
                                        <v-row>
                                            <v-col cols="12" class="mt-2 d-flex align-center mb-n5">
                                                <span><strong>Data:</strong> {{ dataset.data.proposal_creditor_at |
                                                    defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                            </v-col>

                                            <v-col cols="12" class="d-flex align-center">
                                                <span>
                                                    <strong>Status:</strong>
                                                    <v-chip small class="ml-2 white--text"
                                                        :color="dataset.data.proposal_status === 1 ? 'green' : dataset.data.proposal_status === 2 ? 'red' : 'grey'">
                                                        {{
                                                            dataset.data.proposal_status === 1 ? 'Aprovado' :
                                                                dataset.data.proposal_status === 2 ? 'Rejeitado' : 'Indefinido'
                                                        }}
                                                    </v-chip>
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <v-alert v-else type="info" color="warning" outlined icon="mdi-clock-outline">
                                        <template v-slot:prepend>
                                            <v-icon color="grey darken-4">mdi-clock-outline</v-icon>
                                        </template>
                                        <span class="text--primary ml-3">O credor ainda não respondeu à
                                            contraproposta.</span>
                                    </v-alert>
                                </v-card>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Revisão Crédito - BLOCO 2-->
        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">
                                    Revisão -
                                    {{ dataset && dataset.data && dataset.data.type === 4
                                        ? 'DEVEDORA'
                                        : 'CREDOR'
                                    }}
                                </span>
                                <!-- <v-chip
                                    small class="text-uppercase font-weight-bold text-caption ml-2"
                                    :color="typeChip.color" label text-color="white"
                                >
                                    {{ typeChip.label }}
                                </v-chip> -->

                            </div>
                            <v-col cols="3">
                                <v-progress-linear :value="dataset.loading ? undefined : progress" color="green"
                                    height="20" rounded :indeterminate="dataset.loading">
                                    <strong v-if="!dataset.loading" class="centered">{{ progress }}% analisados</strong>
                                    <span v-else class="centered">Carregando...</span>
                                </v-progress-linear>

                            </v-col>
                        </div>

                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <!-- <strong>Revisão de Crédito</strong>
                                        <br /> -->
                                        <strong>Devedora: </strong> <span>{{ dataset.data.client ?
                                            dataset.data.client.name
                                            : '' }}</span>
                                        <br />
                                        <strong>Solicitado em: </strong>
                                        <span>{{
                                            dataset.data.created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                        }}</span>
                                        <br />
                                        <!--
                                        <v-row>
                                            <v-col cols="3">
                                                <strong>Total de casos analisados: </strong>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-progress-linear :value="progress" color="green" height="20"
                                                    class="mb-3" rounded>
                                                    <strong>{{ progress }}%</strong>
                                                </v-progress-linear>
                                            </v-col>
                                        </v-row>
                                        --->

                                    </v-col>
                                </v-row>
                                <v-row v-if="!dataset.loading">
                                    <v-col>
                                        <strong>Resultado: </strong>
                                        <v-chip small label class="mr-10" :color="getColorByStatus(getFinalStatus())">
                                            {{ getFinalStatus() | enum(dataset.eventStatus, 'id',
                                                'name') }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <v-row v-if="dataset.data && dataset.data.type === 4">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-bold mt-4">Decisão do credor: </span>
                                          <v-chip
                                            :color="creditorDecisionStatus(dataset.data.creditor_decision).color"
                                            class="white--text" label small>
                                            {{ creditorDecisionStatus(dataset.data.creditor_decision).text }}
                                        </v-chip>

                                        <br/>
                                        <strong>Decidido em: </strong>
                                            <span>
                                                {{ dataset.data.creditor_decision_at && dataset.data.creditor_decision_at !== '0000-00-00 00:00:00'
                                                    ? $moment(dataset.data.creditor_decision_at).format('DD/MM/YYYY HH:mm:ss')
                                                    : 'Pendente' }}
                                            </span>
                                      
                                    </v-col>
                                    <v-col cols="12">
                                        <p class="font-weight-bold mt-4">Motivo da decisão</p>
                                        <span>{{ dataset.data.creditor_decision_reason || 'N/A' }}</span>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="!dataset.loading && (!dataset.data.currentReview || dataset.data.currentReview.status !== 0)">
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="#B39DDB" class="mr-5" small v-if="(dataset.data.status && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6 && dataset.data.status !== 7)
                                            || !$check(user, ['objectionevents.restore'])"
                                            @click="statusReset()">Restaurar</v-btn>

                                        <v-btn type="button" elevation="0" color="accent" class="mr-5" small
                                            :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6 && dataset.data.status !== 7) || !getFinalStatus()"
                                            @click="updateStatus()">Confirmar</v-btn>

                                        <v-btn type="button" elevation="0" color="#FF8F00" small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6 && dataset.data.status !== 7)
                                            || !$check(user, ['objectionevents.update.eventitem.review'])"
                                            @click="createReview()" class="mr-5">Enviar
                                            para revisão</v-btn>

                                        <v-btn type="button" elevation="0" color="#7E55AB" class="mr-5 white--text"
                                            small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6 && dataset.data.status !== 7)
                                                || !$check(user, ['objectionevents.update.eventitem.docs'])"
                                            @click.stop="openRequestDoc()">Solicitar
                                            Documento</v-btn>

                                        <v-btn type="button" elevation="0" color="primary" class="mr-5 white--text"
                                            small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6 && dataset.data.status !== 7)
                                                || !$check(user, ['objectionevents.create.eventitem'])"
                                            @click.stop="openCreateBusinessModal()">Adicionar
                                            Negócio</v-btn>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <span><strong>NEGÓCIO(S)</strong></span>
                                    </v-col>
                                </v-row>

                                <v-row v-if="!dataset.loading && dataset.data.currentReview && $check(user, ['objectionevents.update.eventitem.action'])">
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="accent" class="mr-5"
                                                    small @click="updateReview(dataset.data, 1)">Aprovar</v-btn>
                                            </template>
                                            <span>Clique no botão para aprovar a revisão.</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="error" class="mr-5"
                                                    small @click="updateReview(dataset.data, 2)">Rejeitar</v-btn>
                                            </template>
                                            <span>Clique no botão para rejeitar a revisão.</span>
                                        </v-tooltip>

                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div>
                                            <div v-if="dataset.loading" class="loading-container">
                                                <v-progress-circular indeterminate color="green" size="50"
                                                    class="my-5"></v-progress-circular>
                                                <span>Carregando...</span>
                                            </div>
                                            <v-expansion-panels v-else>

                                                <v-expansion-panel v-for="(eventItem, eventIndex) in dataset.data.items"
                                                    :key="eventIndex">

                                                    <!-- <div
                                                        :class="eventItem.isChecked ? 'checkbox-marked-wrapper' : 'checkbox-wrapper'">
                                                        <v-checkbox v-model="eventItem.isChecked" class="ml-3"
                                                            color="green"
                                                            @change="toggleCheckbox(eventItem)"></v-checkbox>
                                                    </div> -->

                                                    <v-expansion-panel-header @click.stop>
                                                        <div class="d-flex align-center">
                                                            <div>
                                                                <strong>ID: </strong>
                                                                <span class="ml-2 mr-2">#{{ eventItem.id }}</span> /
                                                                <strong>Origem: </strong>
                                                                <span class="ml-2 mr-2">{{ truncateText(eventItem.origin
                                                                    ||
                                                                    'N/A', 30) }}</span> /
                                                                <strong class="ml-2">Valor: </strong>
                                                                <span class="ml-2" v-if="eventItem.amount">
                                                                    {{ eventItem.currency | enum(dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat') }}
                                                                    {{ eventItem.amount | currency }}
                                                                </span>
                                                                <span v-else>N/A</span>
                                                                <template v-if="eventItem.fgts_amount">
                                                                    <span class="ml-2">/</span>
                                                                    <strong class="ml-2">Valor FGTS: </strong>
                                                                    <span v-if="eventItem.fgts_amount">
                                                                        R$ {{ eventItem.fgts_amount | currency }}
                                                                    </span>
                                                                    <span v-else>N/A</span>
                                                                </template>
                                                            </div>

                                                            <v-spacer></v-spacer>

                                                            <v-chip label class="mr-10" small
                                                                :color="getColorByStatus(eventItem.status, eventItem.proposal_status)"
                                                                style="color: white">
                                                                {{ eventItem.status | enum(dataset.eventStatus, 'id',
                                                                    'name') }}
                                                            </v-chip>

                                                            <v-chip v-if="eventItem.contradictory_status === 3" label
                                                                small :color="getCounterProposalColor(eventItem)"
                                                                class="mr-4 white--text">
                                                                {{ getCounterProposalLabel(eventItem) }}
                                                            </v-chip>

                                                            <template v-if="!eventItem.isEditing">
                                                                <v-tooltip bottom :disabled="!eventItem.status">
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 0)"
                                                                            :disabled="eventItem.status === 0 || eventItem.status === 4 || eventItem.status === 5
                                                                                || !$check(user, ['objectionevents.restore'])"
                                                                            size="large">
                                                                            <v-icon>mdi-refresh-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para restaurar o status do
                                                                        negócio</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, eventItem.partial_amount ? 3 : 1)"
                                                                            size="large"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !$check(user, ['objectionevents.action'])"
                                                                            :color="eventItem.partial_amount ? '#FF8F00' : 'green'">
                                                                            <v-icon>mdi-check-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span v-if="!eventItem.partial_amount">
                                                                        Clique no botão para aprovar este negócio e
                                                                        confirmar as
                                                                        informações enviadas.
                                                                    </span>
                                                                    <span v-else>
                                                                        Clique no botão para aprovar parcialmente este
                                                                        negócio,
                                                                        confirmando-o com o valor atualizado,
                                                                        diferente do originalmente enviado.
                                                                    </span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 2)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !$check(user, ['objectionevents.action'])"
                                                                            size="large" color="red">
                                                                            <v-icon>mdi-close-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para rejeitar este negócio
                                                                        caso as
                                                                        informações não atendam aos critérios
                                                                        necessários.</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="editItem(eventItem, eventIndex)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4
                                                                                || !$check(user, ['objectionevents.update.eventitem'])"
                                                                            size="large" color="primary" class="me-2">
                                                                            <v-icon>mdi-pencil-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Clique no botão para habilitar a edição dos
                                                                        campos deste
                                                                        negócio e atualizar as informações conforme
                                                                        necessário.</span>
                                                                </v-tooltip>
                                                            </template>

                                                            <div v-if="eventItem.isEditing"
                                                                class="button-group ml-auto mr-10">
                                                                <v-btn
                                                                    :disabled="!$check(user, ['objectionevents.update.eventitem'])"
                                                                    @click.stop="saveEdit(eventItem)" small
                                                                    elevation="0" color="primary">
                                                                    Salvar
                                                                </v-btn>
                                                                <v-btn @click.stop="cancelEditItem(eventItem)" small
                                                                    elevation="0" color="error">
                                                                    Cancelar
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </v-expansion-panel-header>

                                                    <v-expansion-panel-content>
                                                        <v-row>
                                                            <v-col>
                                                                <p>
                                                                    <span class="section-info-title">Devedora</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="4">
                                                                                <v-autocomplete dense
                                                                                    :items="dataset.clients"
                                                                                    v-model="eventItem.company_name"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto"
                                                                                    required :rules="[$rules.required]"
                                                                                    no-data-text="Nenhuma devedora encontrada"></v-autocomplete>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{ eventItem.company_name }}
                                                                        </span>
                                                                    </template>
                                                                </p>
                                                                <p>
                                                                    <span class="section-info-title">Origem</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="4">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="origin"
                                                                                    :items="dataset.creditorOriginTypes"
                                                                                    label="Selecione a origem"
                                                                                    v-model="eventItem.origin"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{ eventItem.origin }}</span>
                                                                    </template>
                                                                </p>

                                                                <v-row>
                                                                    <v-col cols="4">
                                                                        <span class="section-info-title">Classe</span>
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-autocomplete dense
                                                                                :items="dataset.creditorTypes"
                                                                                v-model="eventItem.type" item-value="id"
                                                                                item-text="name" outlined
                                                                                hide-details="auto" required
                                                                                :rules="[$rules.required]"
                                                                                no-data-text="Nenhuma classe encontrada"
                                                                                @change="onAutocompleteChange(eventIndex)"
                                                                                :disabled="!$check(user, ['objectionevents.update.eventitem'])"></v-autocomplete>
                                                                        </template>
                                                                        <template v-else>
                                                                            <br />
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    getCreditorTypeName(eventItem.type)
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </v-col>
                                                                </v-row>

                                                                <br />
                                                                <p>
                                                                    <span class="section-info-title">Moeda</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="4">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="type"
                                                                                    :items="dataset.currencyTypes"
                                                                                    label="Selecione uma moeda"
                                                                                    v-model="eventItem.currency"
                                                                                    item-value="id" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value text-uppercase">
                                                                            {{
                                                                                eventItem.currency
                                                                                | enum(
                                                                                    dataset.currencyTypes,
                                                                                    'id',
                                                                                    'name'
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </template>
                                                                </p>

                                                                <template>
                                                                    <p>
                                                                        <span class="section-info-title">Valor indicado 
                                                                            {{ dataset && dataset.data && dataset.data.type === 4
                                                                                ? 'pela devedora'
                                                                                : 'pelo credor'
                                                                            }}
                                                                        </span>
                                                                        <br />
                                                                        <template>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                enum(dataset.currencyTypes, 'id',
                                                                                    'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.amount | currency }}
                                                                            </span>
                                                                        </template>
                                                                    </p>
                                                                    <p>
                                                                        <span class="section-info-title">Valor definido
                                                                            pelo
                                                                            AJ</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="4">
                                                                                    <v-currency-field
                                                                                        :disabled="dataset.loading && !$check(user, ['objectionevents.update.eventitem'])"
                                                                                        label="Valor" dense
                                                                                        aria-label="Digite o valor"
                                                                                        v-model="editedPartialAmount"
                                                                                        :allowNegative="false"
                                                                                        hide-details="auto" outlined>
                                                                                    </v-currency-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                enum(dataset.currencyTypes, 'id',
                                                                                    'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.partial_amount | currency
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </p>
                                                                    <p>
                                                                        <span class="section-info-title">Número
                                                                            pedido</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="4">
                                                                                    <v-text-field
                                                                                        v-model="editedRequestNumber"
                                                                                        outlined dense
                                                                                        hide-details="auto"
                                                                                        :disabled="!$check(user, ['objectionevents.update.eventitem'])">
                                                                                    </v-text-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value text-uppercase">
                                                                                <span
                                                                                    class="section-info-value text-uppercase">
                                                                                    {{
                                                                                        eventItem.request_number &&
                                                                                            eventItem.request_number !==
                                                                                            'undefined'
                                                                                            ? eventItem.request_number
                                                                                            : 'N/A'
                                                                                    }}
                                                                                </span>
                                                                            </span>
                                                                        </template>
                                                                    </p>

                                                                </template>


                                                                <p>
                                                                    <span class="section-info-title">Observações</span>
                                                                    <br />
                                                                    <span class="section-info-value text-uppercase">
                                                                        {{ eventItem.observation ?
                                                                            eventItem.observation
                                                                            : 'Não há observações registradas' }}</span>
                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Motivo</span>
                                                                    <br />

                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="12">
                                                                                <tiptap-vuetify
                                                                                    class="custom-editor-short"
                                                                                    v-model="editedReason"
                                                                                    :rules="[$rules.required]"
                                                                                    :extensions="extensions"
                                                                                    hide-details="auto" />
                                                                                <v-tooltip bottom>
                                                                                    <template #activator="{ on }">
                                                                                        <v-icon v-on="on"
                                                                                            @click="openDialogDynamicText('editedReason')"
                                                                                            class="me-2">
                                                                                            mdi-text-long
                                                                                        </v-icon>
                                                                                    </template>
                                                                                    <span>Selecionar textos longos
                                                                                        predefinidos</span>
                                                                                </v-tooltip>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-if="!eventItem.reason"
                                                                            class="section-info-value text-uppercase">
                                                                            Não há motivos registrados
                                                                        </span>
                                                                        <div v-else v-html="eventItem.reason"></div>
                                                                    </template>


                                                                </p>
                                                                <template v-if="eventItem.contradictory_status !== 3">
                                                                    <p>
                                                                        <span class="section-info-title"
                                                                            color="red">Contraditório</span>
                                                                        <br />

                                                                        <template v-if="eventItem.contradictory_reason">
                                                                            <v-chip small label class="mr-10 mt-4"
                                                                                :color="getColorByStatus(eventItem.contradictory_status)">
                                                                                {{ eventItem.contradictory_status |
                                                                                enum(dataset.eventStatus, 'id',
                                                                                    'name') }}
                                                                            </v-chip>
                                                                            <br />
                                                                            <br />
                                                                            <strong>Valor indicado: </strong>
                                                                            <span v-if="eventItem.contradictory_amount">
                                                                                {{ eventItem.contradictory_amount |
                                                                                    currency }}
                                                                            </span>
                                                                            <span v-else>N/A</span>
                                                                            <br />
                                                                            <br />
                                                                            <strong>Documentos: </strong>
                                                                            <template
                                                                                v-if="eventItem.contradictory_docs">
                                                                                <br />
                                                                                <span
                                                                                    v-for="(item, index) in resolveContradictoryDocs()"
                                                                                    :key="index">
                                                                                    - <a :href="item">{{ item
                                                                                        }}</a><br />
                                                                                </span>
                                                                            </template>
                                                                            <span v-else>N/A</span>
                                                                            <br />
                                                                            <br />
                                                                            <strong>Motivo </strong>
                                                                            <br />
                                                                            <div
                                                                                v-html="eventItem.contradictory_reason">
                                                                            </div>
                                                                        </template>

                                                                    </p>
                                                                </template>

                                                                <!-- BLOCO: Decisão do credor sobre a contraproposta (dentro do negócio) -->
                                                                <div class="mt-4" v-if="eventItem.contradictory_status == 3">
                                                                    <v-divider class="mb-3"></v-divider>
                                                                    <h4 class="mb-2">Decisão do credor sobre a
                                                                        contraproposta</h4>
                                                                            <span><strong>Status:</strong></span>
                                                                            <v-chip small class="ml-2 white--text"
                                                                                :color="eventItem.contradictory_creditor_decision === 1 ? 'green' : eventItem.contradictory_creditor_decision === 2 ? 'red' : 'grey'">
                                                                                {{
                                                                                    eventItem.contradictory_creditor_decision
                                                                                        === 1 ? 'Aprovado' :
                                                                                eventItem.contradictory_creditor_decision
                                                                                === 2 ?
                                                                                'Rejeitado' : 'Pendente'
                                                                                }}
                                                                            </v-chip>

                                                                            <br/>
                                                                            <br/>
                                                                            
                                                                            <span><strong>Data da
                                                                                decisão:</strong></span>
                                                                                <br/>
                                                                                <span>
                                                                                    {{
                                                                                        eventItem.contradictory_creditor_decision_at
                                                                                        &&
                                                                                        eventItem.contradictory_creditor_decision_at
                                                                                        !== '0000-00-00 00:00:00' ? 
                                                                                $moment(eventItem.contradictory_creditor_decision_at).format('DD/MM/YYYY HH:mm:ss') : 'N/A' }}
                                                                            </span>
                                                                            <br/>
                                                                            <br/>
                                                                            <span><strong>Valor:</strong></span>
                                                                            <br/>
                                                                           <span v-if="eventItem.contradictory_amount">
                                                                                {{ eventItem.contradictory_amount |
                                                                                    currency }}
                                                                            </span>
                                                                            <br/>
                                                                            <br/>
                                                                </div>

                                                                <!-- <p>
                                                                    <span class="section-info-title">Documentos</span>
                                                                    <br />
                                                                    <span class="section-info-value">{{
                                                                        eventItem.docs.length
                                                                        }}
                                                                        arquivo(s)</span>
                                                                </p>
                                                             -->
                                                                <p>
                                                                    <span class="section-info-title">Documentos</span>
                                                                    <br />

                                                                    <!-- LINKS EXTERNOS -->
                                                                    <span v-if="hasExternalDocuments(eventItem)"
                                                                        class="section-info-value">
                                                                        {{ parsedDebtorDocuments(eventItem).length }}
                                                                        arquivo(s)
                                                                    </span>

                                                                    <!-- DOCUMENTOS INTERNOS -->
                                                                    <span v-else class="section-info-value">
                                                                        {{ eventItem.docs.length || 0 }} arquivo(s)
                                                                    </span>
                                                                </p>


                                                                <!-- DOCUMENTOS DA DEVEDORA -->
                                                                <v-row v-if="hasExternalDocuments(eventItem)">
                                                                    <v-col
                                                                        v-for="(doc, index) in parsedDebtorDocuments(eventItem)"
                                                                        :key="index" cols="12">
                                                                        <v-icon small class="mr-2">mdi-link</v-icon>

                                                                        <a :href="doc" target="_blank" rel="noopener"
                                                                            class="text-decoration-underline">
                                                                            Documento {{ index + 1 }}
                                                                        </a>
                                                                    </v-col>
                                                                </v-row>


                                                                <!-- DOCUMENTOS PADRÃO -->
                                                                <template v-else>
                                                                    <v-divider
                                                                        v-if="eventItem.docs && eventItem.docs.length"></v-divider>
                                                                    <br>

                                                                    <v-row
                                                                        v-for="category in getEventItemsByCategory(eventItem)"
                                                                        :key="category.id">
                                                                        <v-col cols="12">
                                                                            <h3>{{ category.name }}</h3>
                                                                            <br>

                                                                            <v-row>
                                                                                <v-col v-for="doc in category.docs"
                                                                                    :key="doc.id" cols="auto">
                                                                                    <v-img
                                                                                        @click="openDoc(doc.file_url)"
                                                                                        :class="[
                                                                                            'rounded-xl',
                                                                                            verifyIsRequestedDoc(doc)
                                                                                                ? 'doc-active-class'
                                                                                                : 'doc-inactive-class'
                                                                                        ]" lazy-src="https://picsum.photos/id/11/10/6"
                                                                                        :height="100" :width="100"
                                                                                        :src="doc.file_url" />
                                                                                    {{ doc.name }}
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-col>
                                                                    </v-row>
                                                                </template>

                                                                <!-- <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                                <br>
                                                                <v-row
                                                                    v-for="category in getEventItemsByCategory(eventItem)"
                                                                    :key="category.id">
                                                                    <v-col cols="12">
                                                                        <h3>{{ category.name }}</h3>
                                                                        <br>
                                                                        <v-row>
                                                                            <v-col v-for="doc in category.docs"
                                                                                :key="doc.id" cols="auto">
                                                                                <v-img @click="openDoc(doc.file_url)"
                                                                                    :class="['rounded-xl', verifyIsRequestedDoc(doc) ? 'doc-active-class' : 'doc-inactive-class']"
                                                                                    lazy-src="https://picsum.photos/id/11/10/6"
                                                                                    :height="100" :width="100"
                                                                                    :src="doc.file_url">
                                                                                </v-img>
                                                                                {{ doc.name }}
                                                                                <br>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row> -->
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-col>
                                </v-row>
                                <!-- <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row> -->
                            </v-col>
                        </v-row>

                        <v-row v-if="dataset.qgcRuleTypes && dataset.qgcRuleTypes.length">
                            <v-col cols="12" md="6">
                                <p class="font-weight-bold mt-4">Regra</p>
                                <v-select dense outlined hide-details="auto"
                                    :items="dataset.qgcRuleTypes"
                                    item-value="id"
                                    item-text="name"
                                    :disabled="!$check(user, ['objectionevents.update.requests'])"
                                    v-model="dataset.data.user_creditor_rule"
                                    @change="saveSelectedRule(dataset.data)">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="$check(user, ['objectionevents.view.reason'])">
                            <v-col cols="12">
                                <p class="font-weight-bold mt-4">Motivo longo</p>
                                <tiptap-vuetify class="custom-editor-long"
                                    :disabled="(dataset.data.status == 1 || dataset.data.status == 2 || dataset.data.status == 3)
                                        && !$check(user, ['objectionevents.update.reason'])"
                                    v-model="dataset.data.reason" :extensions="extensions"
                                    :rules="[$rules.required]" hide-details="auto"
                                    @input="reasonUpdateRemainingChars"
                                    @keydown="reasonCheckMaxChars"
                                    @paste.native="reasonUpdateRemainingChars" />
                                <div class="char-counter">
                                    <span :class="{ 'text-red': dataset.reasonRemainingChars <= 10 }">
                                        {{ dataset.reasonRemainingChars }} / {{ dataset.reasonMaxChars }}
                                    </span>
                                </div>
                                <v-alert v-if="dataset.reasonShowExceedMessage" type="error" dense>
                                    O texto excede o limite máximo de {{ dataset.reasonMaxChars }} caracteres.
                                </v-alert>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon v-on="on" @click="openDialogDynamicText('reason')"
                                            class="me-2">
                                            mdi-text-long
                                        </v-icon>
                                    </template>
                                    <span>Selecionar textos longos predefinidos</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row v-if="$check(user, ['objectionevents.update.reason'])">
                            <v-col>
                                <v-btn type="button" elevation="0" color="primary"
                                    @click="saveReason(dataset.data)">
                                    Salvar motivo
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="!dataset.loading && dataset.data.proposal_amount > 0 && dataset.data.proposal_at !== '0000-00-00 00:00:00'"
                            class="mt-4">
                            <v-col cols="12">
                                <v-card flat outlined class="pa-4" style="background-color: #f9f9f9;">
                                    <h3 class="mb-4">Contraproposta</h3>

                                    <v-card class="mb-4 pa-3" flat outlined style="border: 2px solid #78909C;">
                                        <v-row>
                                            <v-col cols="12" class="d-flex align-center mb-n5">
                                                <span>
                                                    <strong>Data de envio:</strong>
                                                    {{ dataset.data.proposal_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}
                                                </span>
                                            </v-col>
                                            <v-col cols="12" class="mb-n5">
                                                <span><strong>Validade:</strong> {{ dataset.data.proposal_deadline_at |
                                                    defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                            </v-col>
                                            <v-col cols="12">
                                                <span><strong>Valor proposto:</strong> R$ {{
                                                    dataset.data.proposal_amount | currency }}</span>
                                            </v-col>
                                            <v-col cols="12" v-if="dataset.data.proposal_doc_url">
                                                <v-tooltip bottom>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn color="primary" outlined small
                                                            :href="dataset.data.proposal_doc_url" target="_blank"
                                                            v-bind="attrs" v-on="on">
                                                            Visualizar documento
                                                        </v-btn>
                                                    </template>
                                                    <span>Visualizar documento da contraproposta</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="dataset.data.proposal_status !== 0 && dataset.data.proposal_creditor_at !== '0000-00-00 00:00:00'"
                                        class="mb-4 pa-3" flat outlined :style="`border: 2px solid ${dataset.data.proposal_status === 1 ? '#4CAF50' :
                                                dataset.data.proposal_status === 2 ? '#F44336' : '#9E9E9E'
                                            };`">
                                        <h4 class="mb-2">Resposta credor:</h4>
                                        <v-row>
                                            <v-col cols="12" class="mt-2 d-flex align-center mb-n5">
                                                <span><strong>Data:</strong> {{ dataset.data.proposal_creditor_at |
                                                    defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                            </v-col>

                                            <v-col cols="12" class="d-flex align-center">
                                                <span>
                                                    <strong>Status:</strong>
                                                    <v-chip small class="ml-2 white--text"
                                                        :color="dataset.data.proposal_status === 1 ? 'green' : dataset.data.proposal_status === 2 ? 'red' : 'grey'">
                                                        {{
                                                            dataset.data.proposal_status === 1 ? 'Aprovado' :
                                                                dataset.data.proposal_status === 2 ? 'Rejeitado' : 'Indefinido'
                                                        }}
                                                    </v-chip>
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <v-alert v-else type="info" color="warning" outlined icon="mdi-clock-outline">
                                        <template v-slot:prepend>
                                            <v-icon color="grey darken-4">mdi-clock-outline</v-icon>
                                        </template>
                                        <span class="text--primary ml-3">O credor ainda não respondeu à
                                            contraproposta.</span>
                                    </v-alert>
                                </v-card>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="dataset.data.status === 4">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Documentos solicitados</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row v-for="(doc, index) in getRequestDoc()" :key="index">
                                    <v-col v-if="doc">
                                        <span class="primary--text" color="primary">
                                            - <strong>Negócio #{{ doc.user_event_item_id }}: </strong>
                                            {{ getDocName(doc) }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="$check(user, ['objectionevents.update.files'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Documento apoio</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-file-input dense accept="image/png, image/jpeg, application/pdf"
                                            prepend-icon="" outlined counter
                                            hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                            label="Documento" :clearable="true" @change="onFileSelected($event)"
                                            show-size truncate-length="50" ref="file"
                                            :disabled="!$check(user, ['objectionevents.update.files'])">
                                        </v-file-input>

                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-card-text>

                                <template>
                                    <v-row class="mt-n5">
                                        <v-col cols="12">
                                            <v-btn class="mr-4" type="button" elevation="0" color="primary"
                                                :disabled="!$check(user, ['objectionevents.update.files'])"
                                                :loading="dataset.loading" @click="updateHelpDoc()">{{
                                                    dataset.data.help_doc_url ? 'Atualizar' : 'Salvar' }}
                                            </v-btn>
                                            <v-btn type="button" elevation="0" color="primary" outlined
                                                v-if="dataset.data.help_doc_url" :href="dataset.data.help_doc_url"
                                                target="_blank">Visualizar
                                                documento
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-card-text>

                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="$check(user, ['objectionevents.view.comments'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Comentários</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text v-for="(item, index) in dataset.data.comments" :key="index">
                                <v-row>
                                    <v-col>
                                        <span class="primary--text" color="primary">{{ item.admin ? item.admin.name :
                                            "" }}
                                            <strong>({{ item.created_at | defaultDate }})</strong></span>
                                        <br>
                                        <div v-html="item.comments.toString().trim()" class="div-comments"></div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Novo comentário</p>
                                        <tiptap-vuetify class="custom-editor-short"
                                            :disabled="dataset.data.status !== 0 && !$check(user, ['objectionevents.create.comment'])"
                                            v-model="dataset.comment" :rules="[$rules.required]"
                                            :extensions="extensions" hide-details="auto" />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="primary" @click="saveComment"
                                            :disabled="!$check(user, ['objectionevents.create.comment'])">Salvar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <!-- <v-row v-if="$check(user, ['objectionevents.view.reason'])">
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Motivo</span>
                                        <br>
                                        <span class="text-subtitle-2 text-none font-weight-medium">Motivo para aprovação
                                            ou
                                            rejeição</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>

                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Texto curto</p>
                                        <tiptap-vuetify class="custom-editor-short" :disabled="(dataset.data.status == 1 || dataset.data.status == 2 || dataset.data.status == 3)
                                            && !$check(user, ['objectionevents.update.reason'])"
                                            v-model="dataset.data.smallReason" :rules="[$rules.required]"
                                            :extensions="extensions" hide-details="auto"
                                            @input="smallReasonUpdateRemainingChars" @keydown="smallReasonCheckMaxChars"
                                            @paste.native="smallReasonUpdateRemainingChars" />
                                        <div class="char-counter">
                                            <span :class="{ 'text-red': dataset.smallReasonRemainingChars <= 5 }">
                                                {{ dataset.smallReasonRemainingChars }} / {{ dataset.smallReasonMaxChars
                                                }}
                                            </span>
                                        </div>
                                        <v-alert v-if="dataset.smallReasonShowExceedMessage" type="error" dense>
                                            O texto excede o limite máximo de {{ dataset.smallReasonMaxChars }}
                                            caracteres.
                                        </v-alert>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="openDialogDynamicText('smallReason')"
                                                    class="me-2">
                                                    mdi-text-short
                                                </v-icon>
                                            </template>
                                            <span>Selecionar textos curtos predefinidos</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Texto longo</p>
                                        <tiptap-vuetify class="custom-editor-long" :disabled="(dataset.data.status == 1 || dataset.data.status == 2 || dataset.data.status == 3)
                                            && !$check(user, ['objectionevents.update.reason'])"
                                            v-model="dataset.data.reason" :rules="[$rules.required]"
                                            :extensions="extensions" hide-details="auto"
                                            @input="reasonUpdateRemainingChars" @keydown="reasonCheckMaxChars"
                                            @paste.native="reasonUpdateRemainingChars" />
                                        <div class="char-counter">
                                            <span :class="{ 'text-red': dataset.reasonRemainingChars <= 10 }">
                                                {{ dataset.reasonRemainingChars }} / {{ dataset.reasonMaxChars }}
                                            </span>
                                        </div>
                                        <v-alert v-if="dataset.reasonShowExceedMessage" type="error" dense>
                                            O texto excede o limite máximo de {{ dataset.reasonMaxChars }} caracteres.
                                        </v-alert>

                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="openDialogDynamicText('reason')" class="me-2">
                                                    mdi-text-long
                                                </v-icon>
                                            </template>
                                            <span>Selecionar textos longos predefinidos</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-row v-if="$check(user, ['objectionevents.update.reason'])">
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="primary" @click="saveReason">Salvar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row> -->

        <v-row v-if="$check(user, ['objectionevents.view.logs'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Movimentações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text v-for="(item, index) in dataset.logs" :key="index">
                        <v-row>
                            <v-col>
                                <span class="text-uppercase font-weight-bold primary--text" color="primary">{{
                                    item.created_at | defaultDate }}:</span> {{ item.description }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="!dataset.logs.length">
                        <v-row>
                            <v-col cols="12">
                                Nenhuma movimentação encontrada
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogDynamicText" :width="900">
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <div class="font-weight-bold mt-6 title-page">Textos Automáticos</div>
                            <p class="mt-2">
                                Selecione um texto abaixo para adicionar no motivo
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>
                                <v-list-item two-line
                                    v-for="(item, index) in dataset.dynamicTexts.filter((x) => (targetField == 'smallReason' && x.small_description) || (targetField != 'smallReason' && x.description))"
                                    :key="index" style="cursor: pointer" @click="selectDynamicText(item)">
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <div
                                                v-html="targetField == 'smallReason' ? item.small_description : truncateText(item.description, 150)">
                                            </div>
                                            <v-divider></v-divider>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                            <!-- <v-card class="rounded-lg mb-10" v-for="(item, index) in dataset.dynamicTexts" :key="index"
                                elevation="2">
                                <v-card-title>
                                    {{ item.name }}
                                </v-card-title>
                                <v-card-text>
                                    <div v-html="dynamicTextSmallType ? item.small_description : item.description"></div>
                                </v-card-text>
                            </v-card> -->
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-btn type="button" elevation="0" color="error"
                                @click="dialogDynamicText = false;">Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal para seleção dos documentos a serem requisitados -->
        <v-dialog v-model="dialogRequestDoc" max-width="700px">
            <v-card>
                <v-card-title class="text-center text--darken-2"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Seleção de Documentos
                </v-card-title>

                <v-card-text>
                    <v-container class="pa-0">
                        <br>
                        <p>
                            Selecione o(s) documento(s) que deseja solicitar ao credor <strong>{{ activeRequestDocEvent &&
                                activeRequestDocEvent.user ? activeRequestDocEvent.user.name : '' }}</strong>.
                        </p>
                        <!-- Checkbox para habilitar a exibição dos negócios -->
                        <v-checkbox v-model="currentRequestDocState.selected"
                            label="Selecionar documentos de negócios" class="mt-0 mb-0"
                            @change="handleCheckChange"></v-checkbox>

                        <!-- Seção de documentos de negócios -->
                        <div v-if="currentRequestDocState.selected">
                            <v-divider class="my-4"></v-divider>
                            <span class="font-weight-bold">
                                Selecione o(s) Documento(s) do(s) negócio(s):
                            </span>
                            <v-expansion-panels>
                                <v-expansion-panel v-for="item in activeRequestDocItems" :key="item.id">
                                    <v-expansion-panel-header>
                                        <div class="d-flex align-center">
                                            <strong>Origem: </strong>
                                            <span class="ml-2 mr-2">
                                                {{ truncateText(item.origin || 'N/A', 30) }}
                                            </span>
                                            /
                                            <strong class="ml-2">Valor: </strong>
                                            <span class="ml-2" v-if="item.amount">
                                                {{ item.currency | enum(dataset.currencyTypes, 'id', 'currencyFormat')
                                                }}
                                                {{ item.amount | currency }}
                                            </span>
                                            <span v-else>N/A</span>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-checkbox v-for="doc in businessDocTypes" :key="doc.id" :label="doc.name"
                                            :value="doc.id" v-model="selectedBusinessDocs[item.id].docs"
                                            class="mt-0 mb-0"
                                            @change="handleDocumentSelection(doc.id, item.id)"></v-checkbox>

                                        <!-- Campo de nome personalizado para ID 50 -->
                                        <v-text-field v-if="selectedBusinessDocs[item.id].docs.includes(50)"
                                            v-model="selectedBusinessDocs[item.id].customName"
                                            label="Especifique o documento" outlined dense></v-text-field>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                        <br>
                        <v-row>
                            <v-col>
                                <v-card outlined>
                                    <v-card-text>
                                        <v-row class="align-center">
                                            <v-col cols="12" sm="12" class="d-flex align-center">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-bind="attrs" v-on="on">
                                                            <v-switch v-model="currentRequestDocState.analysisReturn"
                                                                label="Retornar para análise mesmo sem documentos"
                                                                hide-details class="mt-n2"
                                                                @change="switchChange"></v-switch>
                                                        </div>
                                                    </template>
                                                    <span>Se ativado, este pedido retornará para análise mesmo que o
                                                        credor não
                                                        tenha enviado os documentos solicitados.</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :loading="dataset.loading" type="button" elevation="0" color="primary"
                        @click="sendSelectedList">
                        Solicitar
                    </v-btn>
                    <v-btn color="grey" text @click="closeDialogRequestDoc">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Modal adicionar um novo negocio-->
        <v-dialog v-model="dialogCreateBusiness" class="elevation-0" max-width="800px">

            <v-card>
                <v-card-title class="card-title">
                    Adicionar negócio
                </v-card-title>
                <br>
                <v-card-text>
                    <v-form ref="newBusinessForm" v-model="dataForm.validForm">
                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"><strong>Selecione a origem do crédito</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione o motivo que gerou os valores do crédito</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="12">
                                <v-autocomplete :disabled="dataset.loading" dense required
                                    :items="dataset.creditorOriginTypes" label="Selecione a origem do crédito"
                                    v-model="currentNewBusiness.origin" item-value="name" item-text="name"
                                    :rules="[$rules.required]" outlined hide-details="auto"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"><strong>Informe a moeda e o valor referente ao
                                        negócio</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informe o tipo de moeda e o valor devido</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="6">
                                <v-select :disabled="dataset.loading" dense id="type" :items="dataset.currencyTypes"
                                    label="Selecione uma moeda" v-model="currentNewBusiness.currency" item-value="id"
                                    item-text="name" :rules="[$rules.required]" outlined hide-details="auto"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-currency-field :disabled="dataset.loading" label="Valor" dense
                                    aria-label="Digite o valor do negócio" v-model="currentNewBusiness.amount"
                                    :allowNegative="false" hide-details="auto" outlined required
                                    :rules="[$rules.required]"></v-currency-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"> <strong>Selecione a empresa devedora</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione a empresa devedora do crédito</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="12">
                                <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.clients"
                                    label="Selecione a devedora" v-model="currentNewBusiness.company_name"
                                    item-value="name" item-text="name" :rules="[$rules.required]" outlined
                                    hide-details="auto" no-data-text="Nenhuma devedora encontrada"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"> <strong>Informe o número de identificação do
                                        pedido/cotação/contrato/outro</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informe o número de identificação do pedido</span>
                                </v-tooltip>

                            </v-col>

                        </v-row>
                        <v-row class="mt-n4">
                            <v-col cols="12">
                                <v-text-field :disabled="dataset.loading" dense label="Identificação do pedido"
                                    v-model="currentNewBusiness.request_number"
                                    aria-label="Digite o numero de identificação do pedido" outlined hide-details="auto"
                                    :rules="[$rules.required]">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6">
                                <span class="mr-3"> <strong>Informe a classe no
                                        processo</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione a classe no processo</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <span class="mr-3">
                                    <strong>
                                        Data da ocorrência do negócio
                                    </strong>
                                </span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>
                                        Informe a data do negócio
                                    </span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="6">
                                <v-select dense :items="dataset.creditorTypes" label="Classe"
                                    v-model="currentNewBusiness.type" item-value="id" item-text="name" outlined
                                    hide-details="auto" :rules="[$rules.required]">
                                </v-select>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field dense type="date" label="Data" v-model="currentNewBusiness.ref_date"
                                    outlined hide-details="auto">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3">
                                    <strong>Adicione documento(s) comprobatório(s) do negócio</strong>
                                </span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Documentos que comprovem a origem do negócio</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="12" lg="12" class="mt-n4">
                                <v-text-field outlined dense readonly hide-details :rules="[filesRequired]"
                                    prepend-icon="mdi-paperclip" :disabled="dataset.loading" @click="triggerFileInput">
                                    <template v-slot:prepend-inner>
                                        <div class="d-flex flex-wrap align-left v-chips-container">
                                            <v-chip v-for="(file, index) in currentNewBusiness.docs" :key="index"
                                                class="ma-1" outlined small close @click:close="removeFile(index)">
                                                {{ file.name }}
                                            </v-chip>
                                        </div>
                                    </template>
                                </v-text-field>

                                <v-file-input ref="fileInput" dense multiple hide-input @change="addFiles"
                                    style="display: none"></v-file-input>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"><strong>Informe uma observação referente ao negócio</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informações adicionais referente ao negócio</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" class="mt-n4">
                                    <v-textarea :disabled="dataset.loading" dense id="description"
                                    label="Informações Adicionais" :rules="[
                                        $rules.maxlength(
                                            currentNewBusiness.observation,
                                            500
                                        )
                                    ]" counter="500" v-model="currentNewBusiness.observation" outlined
                                    hide-details="auto" rows="2" auto-grow></v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-row class="mt-n5 mr-1 justify-end">
                        <v-col cols="auto">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn v-on="on" color="primary" :loading="dataset.loadingSave"
                                        @click.native="saveNewBusiness">
                                        Salvar
                                    </v-btn>
                                </template>
                                <span>Salvar alterações</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn class="ml-4" v-on="on" type="button" elevation="0" color="primary" outlined
                                        @click="closeDialogCreateBusiness()">
                                        Cancelar
                                    </v-btn>
                                </template>
                                <span>Retornar sem salvar alterações</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

        <!-- Modal solicitar alteração no QGC -->
        <v-dialog v-model="dialogQgcAction" max-width="500px">
            <v-card>
                 <v-card-title class="card-title">
                    Solicitar alteração QGC
                </v-card-title>
                <br>
                <v-card-text v-if="selectedQgcItem">
                    <v-row dense>
                        <v-col cols="12">
                            <strong>Credor:</strong> {{ selectedQgcItem.name }}
                        </v-col>
                        <v-col cols="12">
                            <strong>Classe atual:</strong> {{ getCreditorTypeName(selectedQgcItem.type) }}
                        </v-col>
                        <v-col cols="12">
                            <strong>Valor atual:</strong> R$ {{ selectedQgcItem.amount | currency }}
                        </v-col>
                    </v-row>
                    <br/>
                    <v-row dense>
                        <v-col cols="12">
                            <v-select
                                dense
                                outlined
                                label="Seleção da ação"
                                :items="qgcActionTypes"
                                v-model="qgcActionForm.action_type"
                                item-text="text"
                                item-value="value"
                                hide-details="auto"
                                @change="qgcActionForm.action_new_type = null; qgcActionForm.action_new_amount = null"
                            />
                        </v-col>
                        <v-col cols="12" v-if="qgcActionForm.action_type === 2" class="mt-3">
                            <v-select
                                dense
                                outlined
                                label="Nova classe"
                                :items="dataset.creditorTypes"
                                v-model="qgcActionForm.action_new_type"
                                item-text="name"
                                item-value="id"
                                hide-details="auto"
                            />
                        </v-col>
                        <v-col cols="12" v-if="qgcActionForm.action_type === 3" class="mt-3">
                            <v-currency-field
                                dense
                                outlined
                                label="Novo valor"
                                v-model="qgcActionForm.action_new_amount"
                                :allowNegative="false"
                                hide-details="auto"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="dataset.loading" @click="saveQgcAction">Salvar</v-btn>
                    <v-btn text color="grey" @click="dialogQgcAction = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal detalhes solicitação alteração QGC existente -->
        <v-dialog v-model="dialogQgcActionInfo" max-width="500px">
            <v-card>
                <v-card-title class="card-group-title">
                    Detalhes da Solicitação
                </v-card-title>
                <v-card-text v-if="selectedQgcItem">
                    <v-alert dense outlined color="orange darken-1" icon="mdi-alert-circle" class="mb-4">
                        Já existe uma solicitação de alteração registrada para este item.
                    </v-alert>
                    <v-row dense>
                        <v-col cols="12">
                            <strong>Tipo de ação:</strong>
                            <v-chip x-small class="ml-2" :color="selectedQgcItem.action_type === 1 ? 'red lighten-3' : selectedQgcItem.action_type === 2 ? 'blue lighten-3' : 'green lighten-4'">
                                <strong>{{ selectedQgcItem.action_type === 1 ? 'Exclusão' : selectedQgcItem.action_type === 2 ? 'Alteração de Classe' : 'Alteração de Valor' }}</strong>
                            </v-chip>
                        </v-col>
                        <v-col cols="12" v-if="Number(selectedQgcItem.action_type) === 2">
                            <strong>Nova classe:</strong>
                            {{ getCreditorTypeName(Number(selectedQgcItem.action_value)) }}
                        </v-col>

                        <v-col cols="12" v-if="Number(selectedQgcItem.action_type) === 3">
                            <strong>Novo valor:</strong>
                            R$ {{ parseFloat(selectedQgcItem.action_value) | currency }}
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="grey" @click="dialogQgcActionInfo = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"
import userEventUtil from "@/common/util/user-event.util"

import { cpf, cnpj } from 'cpf-cnpj-validator'

import userTypes from "@/common/data/user-types.data"
import currencyTypes from "@/common/data/currency-types.data"

import documentTypes from "@/common/data/document-types.data"
import creditorTypes from "@/common/data/creditor-types.data"
import eventStatus from "@/common/data/event-status.data"
import creditorEmailDocTypes from "@/common/data/creditor-email-doc-types.data"
import businessDocTypes from "@/common/data/business-doc-types.data"
import creditorOriginTypes from "@/common/data/creditor-origin-types.data.js";
import qgcRuleTypes from "@/common/data/qgc-rule-types.data.js";
import objectionEventTypes from "@/common/data/objection-event-types.data.js";

import axios from "axios"

//import TiptapResizeImage from '@tiptap/extension-resize-image'; nao complica
// @tiptap/extension-im/age-resize -> Nao instala com NPM

//import Image from 'tiptap-extension-image-freely' // erro ao compilar

//import TiptapResizeImage from '@tiptap/extension-image'


import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Table, TableCell, TableHeader,
    TableRow
} from 'tiptap-vuetify'


const buildEmptyBusiness = () => ({
    origin: null,
    amount: null,
    currency: null,
    company_name: null,
    request_number: null,
    type: null,
    ref_date: null,
    docs: [],
    observation: null,
});

const buildRequestDocState = () => ({
    selected: false,
    analysisReturn: false,
});

export default {
    name: "UserDetails",

    components: { 'tiptap-vuetify': TiptapVuetify },

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        targetField: '',
        isReasonExpanded: false,
        selectedBusinessDocs: {},
        activeRequestDocEvent: null,
        activeRequestDocEventId: null,
        activeRequestDocItems: [],
        requestDocStates: {},
        currentRequestDocState: buildRequestDocState(),
        activeNewBusinessEventId: null,
        newBusinessDrafts: {},
        currentNewBusiness: buildEmptyBusiness(),
        // selectedRequestDocs: [],
        // selectedRequestedDocs: [],
        // selectedBusinesses: [],
        // selectedBusinessDocs: {},
        // customDocumentName: "",
        dialogQgcAction: false,
        dialogQgcActionInfo: false,
        selectedQgcItem: null,
        qgcActionForm: {
            action_type: null,
            action_new_type: null,
            action_new_amount: null,
        },
        qgcActionTypes: [
            { text: 'Exclusão', value: 1 },
            { text: 'Alteração de Classe', value: 2 },
            { text: 'Alteração de Valor', value: 3 },
        ],
        expandedPanels: [],
        documentTypes: documentTypes,
        creditorEmailDocTypes: creditorEmailDocTypes,
        creditorBusinessDocType: [{ id: 3, name: 'Documentos comprobatórios' }],
        businessDocTypes: businessDocTypes,
        dataset: {
            loadingReports: false,
            reports: [],
            qgcRuleTypes: qgcRuleTypes,
            userTypes: userTypes,
            currencyTypes: currencyTypes,
            eventStatus: eventStatus,
            objectionEventTypes: objectionEventTypes,
            breadcrumbItems: [],
            states: states,
            creditorTypes: creditorTypes,
            selectedItem: null,
            loading: false,
            loadingSave: false,
            logs: [],
            clients: [],
            creditorOriginTypes: creditorOriginTypes,
            data: {
                smallReason: "",
                reason: "",
                partialAmount: null,
                reasonDocument: null,
                helpDocument: null,
                processes: [],
                review_later: false,
                qgcItems: [],
            },
            partialItems: [],
            dynamicTexts: [],
            events: [],
            comment: "",
            smallReasonRemainingChars: 300,
            smallReasonMaxChars: 300,
            smallReasonShowExceedMessage: false,
            smallReasonIsDeleting: false,

            reasonRemainingChars: 5000,
            reasonMaxChars: 5000,
            reasonShowExceedMessage: false,
            reasonIsDeleting: false,

        },
        isEditing: false,
        editedAmount: null,
        editedPartialAmount: null,
        editedCurrency: null,
        editedReason: null,
        partialAmountError: '',
        editedRequestNumber: null,
        expandedPanel: null,
        progress: 0,
        dialogDynamicText: false,
        dialogPartialAccept: false,
        dynamicTextSmallType: false,
        selectedDoc: null,
        dialogViewDoc: false,
        dialogRequestDoc: false,
        dialogCreateBusiness: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
                options: {
                    levels: [1, 2, 3]
                }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            [Table, {
                options: {
                    resizable: true
                }
            }],
            TableCell,
            TableHeader,
            TableRow,
        ],
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Exemplo de texto com uma imagem:'
                    },
                    {
                        type: 'image',
                        attrs: {
                            src: 'https://via.placeholder.com/150',
                            alt: 'Imagem de exemplo',
                            style: 'width: 150px; height: 150px;'
                        }
                    }
                ]
            }
        ],
    }),

    created() {
        this.setPage();
    },

    watch: {
        'dataset.data.smallReason': function () {
            this.smallReasonUpdateRemainingChars();
        },

        'dataset.data.reason': function () {
            this.reasonUpdateRemainingChars();
        },

        'dataset.data.items': {
            immediate: true,
            handler(newItems) {
                if (newItems) {
                    newItems.forEach(item => {
                        if (!this.selectedBusinessDocs[item.id]) {
                            this.$set(this.selectedBusinessDocs, item.id, {
                                docs: [],
                                origin: item.origin,
                                amount: item.amount,
                            });
                        } else {
                            this.selectedBusinessDocs[item.id].docs = this.selectedBusinessDocs[item.id].docs.map(doc => {
                                return typeof doc === 'object' ? doc : { id: doc, uploaded: false };
                            });
                        }
                    });
                }
            }
        }
    },

    mounted() {
        this.user = this.$root.user.data || this.$root.user;
        console.log(this.user)

        this.loadData();

        // this.initializeAnalysisStatus();
    },

    methods: {
        goBack() {
            this.$router.replace("/revisao-credito");
        },

        openDialogDynamicText(targetField) {
            this.loadDynamicTexts();
            this.targetField = targetField;
            this.dialogDynamicText = true;
        },

        switchChange(value) {
            console.log("🔄 Switch alterado para:", value);

            if (this.currentRequestDocState) {
                this.currentRequestDocState.analysisReturn = value;
            }
        },

        async fetchAnalysisStatus(itemId) {
            try {
                const response = await axios.get(`/api/user-events/item-analysis/${itemId}`);
                if (response.status === 200) {
                    return response.data.content.analysis_status;
                } else {
                    console.error("Erro ao buscar o analysis_status:", response);
                    return 1;
                }
            } catch (error) {
                console.error("Erro ao buscar o analysis_status:", error);
                return 1;
            }
        },

        async initializeAnalysisStatus() {
            this.statusLoading = true;

            try {
                for (let i = 0; i < this.dataset.data.items.length; i++) {
                    const item = this.dataset.data.items[i];

                    const status = await this.fetchAnalysisStatus(item.id);
                    this.$set(this.dataset.data.items[i], 'isChecked', status === 2);
                }

                this.updateProgress();
            } catch (error) {
                console.error("Erro ao inicializar status:", error);
            } finally {
                this.statusLoading = false;
            }
        },

        editPartialAmount(eventItem) {
            this.dataset.data.items.forEach(item => {
                item.isEditingPartialAmount = false;
            });
            eventItem.isEditingPartialAmount = true;
            this.editedPartialAmount = eventItem.partial_amount;
        },

        updateProgress() {
            const totalItems = this.dataset.data.items.length || 0;
            const completedItems = this.dataset.data.items.filter(item => item.status !== 0 && item.status !== 4 && item.status !== 5).length || 0;
            this.progress = Math.round((completedItems / totalItems) * 100);
        },

        toggleCheckbox(eventItem) {
            eventItem.isEditing = false;
            this.expandedPanel = null;

            // Atualize o progresso ao mudar o status
            this.updateProgress();

            const newStatus = eventItem.isChecked ? 2 : 1;

            // Chamar o backend para atualizar o analysis_status
            this.updateBackend(eventItem.id, newStatus);
        },

        async updateBackend(itemId, analysisStatus) {
            try {
                const response = await axios.patch(`/api/user-events/item-analysis/${itemId}`, {
                    analysis_status: Number(analysisStatus)
                });

                if (response.status === 200) {
                    console.log("Analysis status atualizado com sucesso.");
                }
            } catch (error) {
                console.error("Erro ao atualizar o analysis status:", error);
            }
        },

        async saveReviewLater() {

            const isReviewLater = this.dataset.data.review_later;

            const proceedAction = await this.$dialog.confirm({
                text: isReviewLater
                    ? 'Tem certeza que deseja sinalizar o pedido?'
                    : 'Tem certeza que deseja desmarcar o pedido?',
                title: isReviewLater ? 'Sinalizar pedido' : 'Desmarcar pedido',
                actions: {
                    false: 'NÃO',
                    true: 'SIM',
                },
            });

            if (!proceedAction) {
                this.dataset.data.review_later = !isReviewLater;
                return;
            }

            const payload = { review_later: isReviewLater };

            try {
                await axios.patch(`/api/admin/user-objection-events/review-event-later/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Alteração efetuada com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });
            } catch (error) {
                this.dataset.data.review_later = !isReviewLater;

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        async saveSelectedRule(eventContext = this.dataset.data) {

            const eventId = eventContext && eventContext.id ? eventContext.id : this.$route.params.id;
            const selectedRule = eventContext.user_creditor_rule;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja alterar a regra do pedido?',
                title: 'Alterar regra',
                actions: {
                    false: 'NÃO',
                    true: 'SIM',
                },
            });

            if (!proceedAction) {
                return;
            }

            const payload = { user_creditor_rule: selectedRule };

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-objection-events/qgc-rule/${eventId}`, payload);

                this.$dialog.notify.info("Alteração efetuada com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });

                await this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000,
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        async saveCheckedItems() {
            const completedItems = this.dataset.data.items.filter(item => item.isChecked);
            // Aqui você pode enviar os dados para o backend
            await axios.post('/api/update-items', { items: completedItems });
            this.$dialog.notify.info("Itens salvos com sucesso!", { position: "top-right", timeout: 2000 });
        },

        editItem(eventItem, index) {
            this.dataset.data.items.forEach(item => {
                item.isEditing = false;
            });
            eventItem.isEditing = true;
            this.editedAmount = eventItem.amount;
            this.editedPartialAmount = eventItem.partial_amount;
            this.editedRequestNumber = eventItem.request_number;
            this.editedReason = eventItem.reason;

            // this.expandedPanel = index;
        },

        getFinalStatus(customItems = null) {
            const items = Array.isArray(customItems)
                ? customItems
                : (this.dataset.data && Array.isArray(this.dataset.data.items)
                    ? this.dataset.data.items
                    : []);

            if (!items.length) {
                return 0;
            }

            const hasPending = items.some(item => item.status === 0 || item.status === 5);

            if (hasPending) {
                return 0;
            }

            if (items.every(item => item.status === 1)) {
                return 1;
            }

            if (items.every(item => item.status === 2)) {
                return 2;
            }

            return 3;
        },

        openRequestDoc(eventContext = this.dataset.data) {
            if (!eventContext || !eventContext.id) {
                this.$dialog.notify.error("Não foi possível identificar o pedido para solicitar documentos.", { position: "top-right", timeout: 3000 });
                return;
            }

            this.activeRequestDocEvent = eventContext;
            this.activeRequestDocEventId = eventContext.id;
            this.activeRequestDocItems = Array.isArray(eventContext.items) ? eventContext.items : [];

            this.ensureSelectedBusinessDocsForItems(this.activeRequestDocItems);

            if (!this.requestDocStates[eventContext.id]) {
                this.$set(this.requestDocStates, eventContext.id, buildRequestDocState());
            }

            this.currentRequestDocState = this.requestDocStates[eventContext.id];

            this.dialogRequestDoc = true;
        },

        closeDialogCreateBusiness() {
            if (this.activeNewBusinessEventId && this.newBusinessDrafts[this.activeNewBusinessEventId]) {
                this.newBusinessDrafts[this.activeNewBusinessEventId] = buildEmptyBusiness();
            }

            this.currentNewBusiness = buildEmptyBusiness();
            this.activeNewBusinessEventId = null;
            this.dialogCreateBusiness = false;

            if (this.$refs.newBusinessForm) {
                this.$refs.newBusinessForm.resetValidation();
            }
        },

        openCreateBusinessModal(eventContext = this.dataset.data) {
            if (!eventContext || !eventContext.id) {
                this.$dialog.notify.error("Não foi possível identificar o pedido para adicionar um negócio.", { position: "top-right", timeout: 3000 });
                return;
            }

            this.activeNewBusinessEventId = eventContext.id;

            if (!this.newBusinessDrafts[eventContext.id]) {
                this.$set(this.newBusinessDrafts, eventContext.id, buildEmptyBusiness());
            }

            this.currentNewBusiness = this.newBusinessDrafts[eventContext.id];
            this.dialogCreateBusiness = true;
        },

        triggerFileInput() {
            const fileInput = this.$refs.fileInput.$el.querySelector('input[type="file"]');
            if (fileInput) {
                fileInput.click();
            }
        },

        filesRequired() {
            return this.currentNewBusiness && this.currentNewBusiness.docs.length > 0 || "Você deve adicionar pelo menos um documento!";
        },

        addFiles(files) {
            if (!this.currentNewBusiness) {
                this.currentNewBusiness = buildEmptyBusiness();
            }

            this.currentNewBusiness.docs.push(...files);

            this.$refs.newBusinessForm && this.$refs.newBusinessForm.validate();
        },

        removeFile(index) {
            if (!this.currentNewBusiness) return;

            this.currentNewBusiness.docs.splice(index, 1);

            this.$refs.newBusinessForm && this.$refs.newBusinessForm.validate();
        },

        verifyIsRequestedDoc(doc) {
            if (!this.dataset.data || !this.dataset.data.requested_doc) return false;

            let requestedDocs = JSON.parse(this.dataset.data.requested_doc || '[]');

            if (!Array.isArray(requestedDocs)) return false;

            let result = false;

            for (let item of requestedDocs) {
                if (item.user_event_item_id) {
                    for (let docItem of item.docs) {
                        if (docItem.ref_id == doc.ref_id) {
                            result = true;
                            continue;
                        }
                    }
                }
            }

            return result;
        },

        resolveContradictoryDocs() {
            if (!this.dataset.data || !this.dataset.data.contradictory_docs) return [];

            let docs = JSON.parse(this.dataset.data.contradictory_docs || '[]');

            return !Array.isArray(docs) ? [] : docs

        },

        getRequestDoc() {
            return this.dataset.data.requestedDocs || '[]'
        },

        getDocName(doc) {
            const docType = this.businessDocTypes.find(type => type.id === doc.document_id);
            const name = docType ? docType.name : doc.document_id;

            if (doc.document_id === 50) {
                return doc.custom_name || name;
            }

            return name;
        },

        getDocDescription(doc) {
            console.log('this.dataset.creditorEmailDocTypes ', this.dataset.creditorEmailDocTypes)
            return this.dataset.creditorEmailDocTypes.find((x) => x.id == doc) || "n/a"
        },

        formatValue(value, currency) {
            if (value === null || value === undefined) {
                return 'N/A';
            }

            let options = {
                style: 'currency',
                currency: 'BRL'
            };

            switch (currency) {
                case 1:
                    options.currency = 'BRL';
                    break;
                case 2:
                    options.currency = 'USD';
                    break;
                case 3:
                    options.currency = 'EUR';
                    break;
                default:
                    options.currency = 'BRL';
            }

            return new Intl.NumberFormat('pt-BR', options).format(value);
        },

        // async loadCreditorReports() {

        //     this.dataset.loadingReport = true;

        //     try {
        //         const result = await axios.get(`/api/admin/reports/details/${this.dataset.data.user.registration.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '')}`);

        //         this.dataset.reports = result.data.content;

        //     } catch (error) {
        //         console.log('error ', error)
        //         this.$dialog.notify.error(this.$codes(error), {
        //             position: 'top-right',
        //             timeout: 2000
        //         })
        //     } finally {
        //         this.dataset.loadingReport = false;
        //     }
        // },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data;

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.clients = data;

                console.log("Clientes: ", data)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async saveNewBusiness() {

            if (!this.$refs.newBusinessForm.validate()) {
                this.$dialog.notify.error("Verifique se todos os campos obrigatórios foram preenchidos!", {
                    position: "top-right",
                    timeout: 5000,
                });

                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja adicionar o negócio?',
                title: 'Adicionar negócio',
                actions: {
                    false: 'Cancelar',
                    true: 'Adicionar'
                }
            })

            if (!proceedAction) return;

            if (!this.activeNewBusinessEventId) {
                this.$dialog.notify.error("Pedido inválido para adicionar negócio.", { position: "top-right", timeout: 3000 });
                return;
            }

            const payload = this.newBusinessPayload(this.activeNewBusinessEventId);

            this.dataset.loadingSave = true;

            try {

                await axios.post(`/api/admin/user-objection-events/event-item-create`, payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.$dialog.notify.success("Negócio adicionado com sucesso!", {
                    position: "top-right",
                    timeout: 5000,
                });

            } catch (error) {
                this.$dialog.notify.error("Erro ao adicionar o negócio!", {
                    position: "top-right",
                    timeout: 5000,
                });
            } finally {

                this.dataset.loadingSave = false;
                this.closeDialogCreateBusiness();
                this.loadData();
            }
        },

        newBusinessPayload(eventId) {

            const draft = this.currentNewBusiness || buildEmptyBusiness();

            const formData = new FormData();
            formData.append("event_id", eventId);
            formData.append("type", draft.type);
            formData.append("amount", draft.amount);
            formData.append("currency", draft.currency);
            formData.append("origin", draft.origin);
            formData.append("company_name", draft.company_name);
            formData.append("ref_date", draft.ref_date);
            formData.append("request_number", draft.request_number);
            formData.append("observation", draft.observation);

            if (draft.docs && Array.isArray(draft.docs)) {
                draft.docs.forEach((file) => {
                    formData.append("docs[]", file);
                });
            }

            return formData;

        },

        ensureSelectedBusinessDocsForItems(items) {
            if (!Array.isArray(items)) return;

            items.forEach(item => {
                if (!this.selectedBusinessDocs[item.id]) {
                    this.$set(this.selectedBusinessDocs, item.id, {
                        docs: [],
                        customName: '',
                    });
                }
            });
        },

        initializeSelectedBusinessDocs() {
            if (this.dataset.data && Array.isArray(this.dataset.data.items)) {
                this.ensureSelectedBusinessDocsForItems(this.dataset.data.items);
            }

            if (this.dataset.data && Array.isArray(this.dataset.data.debtorData)) {
                this.dataset.data.debtorData.forEach(debtorEvent => {
                    this.ensureSelectedBusinessDocsForItems(debtorEvent.items);
                });
            }
        },

        handleCheckChange(value) {
            if (!value && Array.isArray(this.activeRequestDocItems)) {
                this.activeRequestDocItems.forEach(item => {
                    if (this.selectedBusinessDocs[item.id]) {
                        this.selectedBusinessDocs[item.id].docs = [];
                        this.selectedBusinessDocs[item.id].customName = '';
                    }
                });
            }
        },


        handleDocumentSelection(docId, itemId) {
            if (!this.selectedBusinessDocs[itemId]) {
                this.$set(this.selectedBusinessDocs, itemId, {
                    docs: [],
                    customName: '',
                });
            }

            if (docId === 50 && !this.selectedBusinessDocs[itemId].docs.includes(50)) {
                this.selectedBusinessDocs[itemId].customName = '';
            }
        },


        closeDialogRequestDoc() {
            if (Array.isArray(this.activeRequestDocItems)) {
                this.activeRequestDocItems.forEach(item => {
                    if (this.selectedBusinessDocs[item.id]) {
                        this.selectedBusinessDocs[item.id].docs = [];
                        this.selectedBusinessDocs[item.id].customName = '';
                    }
                });
            }

            if (this.currentRequestDocState) {
                this.currentRequestDocState.selected = false;
                this.currentRequestDocState.analysisReturn = false;
            }

            this.dialogRequestDoc = false;
            this.activeRequestDocEvent = null;
            this.activeRequestDocEventId = null;
            this.activeRequestDocItems = [];
            this.currentRequestDocState = buildRequestDocState();
        },


        async sendSelectedList() {

            if (!this.activeRequestDocEventId || !this.currentRequestDocState) {
                this.$dialog.notify.error(`Selecione um pedido para requisitar documentos!`, { position: "top-right", timeout: 3000 });
                return;
            }

            const eventItems = Array.isArray(this.activeRequestDocItems) ? this.activeRequestDocItems : [];
            const itemIds = eventItems.map(item => item.id);
            const payload = this.requestedDocsPayload(this.activeRequestDocEventId, itemIds);

            const hasBusinessDocs = Object.entries(this.selectedBusinessDocs).some(
                ([key, businessDoc]) => {
                    const numericKey = parseInt(key, 10);
                    return itemIds.includes(numericKey) && businessDoc.docs && businessDoc.docs.length > 0;
                }
            );

            if (!this.currentRequestDocState.selected || !hasBusinessDocs) {
                this.$dialog.notify.error(`Nenhum documento de negócio selecionado!`, { position: "top-right", timeout: 3000 });
                return;
            }

            console.log("Payload: ", payload)

            this.dataset.loading = true;

            try {

                await axios.patch(`/api/admin/user-objection-events/creditor-doc-request/${this.activeRequestDocEventId}`, payload);

                this.$dialog.notify.info("Solicitação enviada com sucesso!", { position: "top-right", timeout: 3000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000,
                });
            } finally {

                this.closeDialogRequestDoc();
                await this.loadData();

            }
        },


        requestedDocsPayload(eventId, allowedItemIds = []) {
            const payload = {
                user_event_id: eventId || null,
                analysis_return: this.currentRequestDocState && this.currentRequestDocState.analysisReturn ? 1 : 0,
                documents: [],
            };

            for (const [itemId, { docs, customName }] of Object.entries(this.selectedBusinessDocs)) {
                const numericItemId = parseInt(itemId, 10);
                if (!allowedItemIds.includes(numericItemId)) continue;

                if (docs.length > 0) {
                    payload.documents = payload.documents.concat(
                        docs.map(docId => ({
                            document_id: docId,
                            user_event_item_id: numericItemId,
                            custom_name: docId === 50 && customName ? customName : null,
                            uploaded: 0,
                        }))
                    );
                }
            }

            console.log('Payload montado:', payload);
            return payload;
        },


        async saveEdit(eventItem) {

            if (this.partialAmountError) {
                this.$dialog.notify.error("Corrija os erros antes de salvar.", {
                    position: "top-right",
                    timeout: 2000,
                });
                return;
            }

            eventItem.amount = this.editedAmount;
            eventItem.partial_amount = this.editedPartialAmount;
            eventItem.request_number = this.editedRequestNumber;
            eventItem.reason = this.editedReason;
            eventItem.isEditing = false;

            this.editedAmount = null;
            this.editedPartialAmount = null;
            this.editedReason = null;
            this.editedReason = null;

            try {
                this.dataset.loading = true;

                const payload = {
                    type: eventItem.type,
                    amount: eventItem.amount,
                    partial_amount: eventItem.partial_amount,
                    request_number: eventItem.request_number,
                    company_name: eventItem.company_name,
                    currency: eventItem.currency,
                    origin: eventItem.origin,
                    reason: eventItem.reason
                };

                await this.updateEventItem(eventItem.id, payload);

                this.$dialog.notify.info("Dados atualizados com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });
                eventItem.isEditing = false;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async changeStatusEventItem(eventItem, status) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja marcar o status como <strong>${userEventUtil.userEventStatusText(status)}</strong> do negócio <strong>#${eventItem.id}</strong>?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-objection-events/item/action/${eventItem.id}`, { status });

                this.$dialog.notify.info("Status definido com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error("Erro ao atualizar status.", {
                    position: "top-right",
                    timeout: 2000,
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateHelpDoc() {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o documento de apoio?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                const formData = new FormData();

                formData.append("help", this.dataset.data.helpDocument)

                await axios.patch(`/api/admin/user-objection-events/help-doc/${this.dataset.data.id}`, formData);

                this.$dialog.notify.info("Documento atualizado com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateReview(eventContext = this.dataset.data, status) {

            if (typeof status === 'undefined') {
                status = eventContext;
                eventContext = this.dataset.data;
            }

            const eventId = eventContext && eventContext.id ? eventContext.id : this.$route.params.id;

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja marcar o status como <strong>${userEventUtil.userEventStatusText(status)}</strong> da revisão?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-objection-events/review/update/${eventId}`, { status });

                this.$dialog.notify.info("Revisão concluída com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async saveReason(eventContext = this.dataset.data) {
            const targetEvent = eventContext && eventContext.id ? eventContext : this.dataset.data;

            if (!targetEvent || !targetEvent.id) {
                this.$dialog.notify.error("Pedido inválido para salvar o motivo.", { position: "top-right", timeout: 2000 });
                return;
            }

            const isMainEvent = this.dataset.data && targetEvent.id === this.dataset.data.id;

            const eventSmallReasonSource =
                targetEvent.smallReason != null
                    ? targetEvent.smallReason
                    : targetEvent.small_reason;
            const eventReasonSource =
                targetEvent.reason != null
                    ? targetEvent.reason
                    : targetEvent.reason_text;

            const eventSmallReason = (eventSmallReasonSource || '').toString();
            const eventReason = (eventReasonSource || '').toString();

            if (!eventReason) {
                this.$dialog.notify.error("Motivo longo é obrigatório.", { position: "top-right", timeout: 2000 });
                return;
            }

            if (eventReason.length > this.dataset.reasonMaxChars) {
                this.$dialog.notify.error("Motivo Longo excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja salvar o motivo?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-objection-events/reason/update/${targetEvent.id}`, { smallReason: eventSmallReason, reason: eventReason });

                this.$dialog.notify.info("Motivo salvo com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async saveComment() {
            if (!this.dataset.comment) {
                this.$dialog.notify.error("Comentário é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            if (this.dataset.comment.length > 1000) {
                this.$dialog.notify.error("Comentário excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja salvar o comentário?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-objection-events/comment/update/${this.dataset.data.id}`, { comment: this.dataset.comment, is_client: false });

                this.$dialog.notify.info("Comentário salvo com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateEventItem(itemId, payload) {
            await axios.patch(`/api/user-objection-events/request/update/${itemId}`, payload);
        },

        cancelEditItem(eventItem) {
            this.editedAmount = eventItem.amount;
            this.editedPartialAmount = eventItem.partial_amount;
            this.editedRequestNumber = eventItem.request_number;
            eventItem.isEditing = false;
        },

        validatePartialAmount(eventItem) {
            if (this.editedPartialAmount > this.editedAmount) {
                this.partialAmountError =
                    "O valor parcial aceito não pode ser maior que o valor total.";
            } else {
                this.partialAmountError = "";
            }
        },


        savePartialAmount(eventItem) {
            eventItem.partial_amount = this.editedPartialAmount;
            eventItem.isEditingPartialAmount = false;
        },

        cancelPartialAmount(eventItem) {
            this.editedPartialAmount = eventItem.partial_amount;
            eventItem.isEditingPartialAmount = false;
        },

        editRequestNumber(eventItem) {
            this.dataset.data.items.forEach(item => {
                item.isEditingRequestNumber = false;
            });
            eventItem.isEditingRequestNumber = true;
            this.editedRequestNumber = eventItem.request_number;
        },

        saveRequestNumber(eventItem) {
            eventItem.request_number = this.editedRequestNumber;
            eventItem.isEditingRequestNumber = false;
        },

        cancelRequestNumber(eventItem) {
            this.editedRequestNumber = eventItem.request_number;
            eventItem.isEditingRequestNumber = false;
        },

        onFileSelected(file) {
            this.dataset.data.helpDocument = file;
        },

        smallReasonUpdateRemainingChars() {
            const currentLength = this.dataset.data.smallReason ? this.dataset.data.smallReason.length : 0;

            this.dataset.smallReasonRemainingChars = this.dataset.smallReasonMaxChars - currentLength;

            if (this.dataset.smallReasonRemainingChars < 0) {
                this.dataset.smallReasonShowExceedMessage = true;
            } else {
                this.dataset.smallReasonShowExceedMessage = false;
            }
        },

        reasonUpdateRemainingChars() {
            const currentLength = this.dataset.data.reason ? this.dataset.data.reason.length : 0;

            this.dataset.reasonRemainingChars = this.dataset.reasonMaxChars - currentLength;

            if (this.dataset.reasonRemainingChars < 0) {
                this.dataset.reasonShowExceedMessage = true;
            } else {
                this.dataset.reasonShowExceedMessage = false;
            }
        },

        smallReasonCheckMaxChars(event) {
            const currentLength = this.dataset.data.smallReason ? this.dataset.data.smallReason.length : 0;

            if (currentLength >= this.dataset.smallReasonMaxChars && event.key !== 'Backspace' && event.key !== 'Delete') {
                event.preventDefault();
            }

            this.dataset.smallReasonIsDeleting = event.key === 'Backspace' || event.key === 'Delete';
        },

        reasonCheckMaxChars(event) {
            const currentLength = this.dataset.data.reason ? this.dataset.data.reason.length : 0;

            if (currentLength >= this.dataset.reasonMaxChars && event.key !== 'Backspace' && event.key !== 'Delete') {
                event.preventDefault();
            }

            this.dataset.reasonIsDeleting = event.key === 'Backspace' || event.key === 'Delete';
        },

        getReasonLength(eventContext) {
            if (!eventContext || !eventContext.reason) {
                return 0;
            }

            return eventContext.reason.length;
        },

        isReasonExceeded(eventContext) {
            return this.getReasonLength(eventContext) > this.dataset.reasonMaxChars;
        },

        stripHtml(html) {
            if (!html) return '';
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            return tempDiv.textContent || tempDiv.innerText || '';
        },

        toggleReason() {
            this.isReasonExpanded = !this.isReasonExpanded;
        },

        getTruncatedReason(reason) {
            const rawText = this.stripHtml(reason);
            if (!this.isReasonExpanded && rawText.length > 150) {
                return rawText.substring(0, 150) + '...';
            }
            return rawText;
        },

        getEventItemsByCategory(eventItem) {
            const categories = {};

            eventItem.docs.forEach(docItem => {
                const category_id = docItem.doc.type;

                if (!categories[category_id]) {
                    categories[category_id] = {
                        id: category_id,
                        name: this.getCategoryName(category_id),
                        docs: []
                    };
                }

                categories[category_id].docs.push({
                    id: docItem.id,
                    name: docItem.doc.name,
                    file_url: docItem.doc.file_url,
                    ref_id: docItem.doc.id
                });
            });

            return Object.values(categories);
        },

        getColorByStatus(status, proposal_status) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                case 3:
                    return '#80CBC4';
                case 5:
                    return '#7E55AB';
                case 6:
                    return '#9E9D24';
                case 7:
                    if (proposal_status === 1) {
                        return '#00695C';
                    }
                    if (proposal_status === 2) {
                        return '#BF360C';
                    }
                    return '#00695C';
                default:
                    return 'grey';
            }
        },

        creditorDecisionStatus(decision) {
            if (decision === 1) {
                return { text: 'Aprovado', color: 'green' };
            }

            if (decision === 2) {
                return { text: 'Rejeitado', color: 'red' };
            }

            return { text: 'Pendente', color: 'grey' };
        },

        getCounterProposalLabel(eventItem) {
            if (!eventItem || eventItem.contradictory_status !== 3) {
                return '';
            }

            if (eventItem.contradictory_creditor_decision === 1) {
                return 'Contraproposta aprovada';
            }

            if (eventItem.contradictory_creditor_decision === 2) {
                return 'Contraproposta rejeitada';
            }

            return 'Contraproposta pendente';
        },

        getCounterProposalColor(eventItem) {
            if (!eventItem || eventItem.contradictory_status !== 3) {
                return '#FF8F00';
            }

            if (eventItem.contradictory_creditor_decision === 1) {
                return 'green';
            }

            if (eventItem.contradictory_creditor_decision === 2) {
                return 'red';
            }

            return '#FF8F00';
        },

        getCategoryName(category_id) {
            return this.documentTypes.find(category => category.id === category_id).name;
        },

        openDoc(doc) {
            window.open(doc, '_blank');
            // this.selectedDoc = doc;
            // this.dialogViewDoc = true;
        },

        truncateText(text, maxLength) {
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },

        updateContraditory(value) {
            this.dataset.data.contradictory_deadline_at = value;
        },

        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            return this.$moment(date).format('YYYY-MM-DD');
        },

        getMessageByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `Usuário acessou o sistema no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'accept-value':
                    result = `Usuário aceitou o crédito no valor de R$ ${this.dataset.data.requested_value} no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'verify-account':
                    result = `Usuário verificou a conta no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'register-user':
                    result = `Usuário criou a conta no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                case 'create-event':
                    result = `Usuário registrou uma divergência no dia ${this.$moment(item.created_at).format('DD/MM/YYYY HH:mm')}`;
                    break;

                default:
                    break;
            }

            return result;
        },

        getTitleByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `acesso`;
                    break;

                case 'accept-value':
                    result = `CRÉDITO`;
                    break;

                case 'verify-account':
                    result = `verificação`;
                    break;

                case 'register-user':
                    result = `cadastro`;
                    break;

                case 'create-event':
                    result = `divergência`;
                    break;

                default:
                    break;
            }

            return result;
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            this.dataset.loading = true;

            try {

                this.setPage();
                this.listBreadCrumbItems();

                await this.load();
                await this.loadLogs();

                await this.loadQgcAdjustedData();

                //await this.loadCreditorReports();

                this.updateProgress();

                await this.loadClients();

                this.initializeSelectedBusinessDocs();

                this.smallReasonUpdateRemainingChars();
                this.reasonUpdateRemainingChars();

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `Detalhes da revisão de crédito`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Revisão de Crédito",
                disabled: false,
                to: "/revisao-credito",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: `Detalhes da revisão de crédito`,
                disabled: true,
                exact: true,
            });
        },

        selectDynamicText(item) {

            if (this.targetField === 'smallReason') {
                this.dataset.data.smallReason += item.small_description;
            } else if (this.targetField === 'editedReason') {
                this.editedReason = (this.editedReason || '') + item.description;
            } else if (this.targetField === 'reason') {
                this.dataset.data.reason += item.description;
            } else if (this.targetField === 'debtorReason') {
                if (this.dataset.data.debtorData && this.dataset.data.debtorData.length) {
                    const currentReason = this.dataset.data.debtorData[0].reason || '';
                    this.$set(this.dataset.data.debtorData[0], 'reason', currentReason + item.description);
                }
            }

            this.dialogDynamicText = false;

            this.smallReasonUpdateRemainingChars();
            this.reasonUpdateRemainingChars();
        },

        async updateStatus(eventContext = this.dataset.data) {

            const eventId = eventContext && eventContext.id ? eventContext.id : this.$route.params.id;

            if (eventId === this.$route.params.id) {
                const debtorData = this.dataset && this.dataset.data && this.dataset.data.debtorData;

                if (
                    Array.isArray(debtorData) &&
                    debtorData.length > 0 &&
                    debtorData[0].status !== 0
                ) {
                    this.$dialog.notify.error(
                        'Existe outro pedido em aberto e o status dele não permite a aprovação deste pedido.',
                        { position: 'top-right', timeout: 3000 }
                    );
                    return;
                }
            }

            const smallReason = (eventContext && eventContext.smallReason) || '';
            const reason = (eventContext && eventContext.reason) || '';

            if (smallReason.length > 300) {
                this.$dialog.notify.error("Motivo Curto excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            if (reason.length > 5000) {
                this.$dialog.notify.error("Motivo Longo excedeu a quantidade máxima de caracteres!", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja confirmar o pedido?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = {
                smallReason,
                reason,
            }

            try {
                await axios.patch(`/api/admin/user-objection-events/action/${eventId}`, payload)

                this.$dialog.notify.info(`Pedido confirmado com sucesso!`, { position: "top-right", timeout: 2000 });

                if (eventId === this.$route.params.id) {
                    this.goBack();
                } else {
                    await this.loadData();
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async createReview(eventContext = this.dataset.data) {

            const eventId = eventContext && eventContext.id ? eventContext.id : this.$route.params.id;

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar para revisão?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.patch(`/api/admin/user-objection-events/review/create/${eventId}`)

                this.$dialog.notify.info(`Pedido enviado para revisão com sucesso!`, { position: "top-right", timeout: 2000 });

                if (eventId === this.$route.params.id) {
                    this.goBack();
                } else {
                    await this.loadData();
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateContradictoryDeadline() {

            if (!this.dataset.data.contradictory_deadline_at) {
                this.$dialog.notify.error("O campo Prazo é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o prazo para contraditórios?`,
                title: `Atualizar revisão de crédito`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-objection-events/contradictory-deadline/${this.$route.params.id}`, { contradictory_deadline_at: this.dataset.data.contradictory_deadline_at })

                this.$dialog.notify.info(`Revisão de Crédito atualizada com sucesso!`, { position: "top-right", timeout: 2000 });

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async load() {

            try {
                const result = await axios.get(`/api/admin/user-objection-events/find/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

                this.dataset.data = {
                    ...data,
                    items: data.items.map(item => ({
                        ...item,
                        isEditing: false,
                        isChanged: false,
                    })),
                };

                this.dataset.data.smallReason = data.small_reason || ""
                this.dataset.data.reason = data.reason || ""

                const registration = this.dataset.data.user.registration;

                if (registration) {
                    this.dataset.data.user.registration = registration.length < 14 ? cpf.format(registration) : cnpj.format(registration);

                    // // 🔹 Busca pedidos da devedora
                    // const debtorResult = await axios.get( '/api/admin/user-objection-events/debtor-requests',
                    //     {
                    //         params: { registration }
                    //     }
                    // );

                    // this.dataset.data.debtorData = debtorResult.data.content;
                }

                this.dataset.data.debtorData = (data.debtorRequests || []).map(request => ({
                    ...request,
                    smallReason: request.smallReason || request.small_reason || "",
                    reason: request.reason || request.reason_long || "",
                    user_creditor_rule: request.user_creditor_rule || null,
                }));

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadLogs() {

            try {
                const result = await axios.get(`/api/admin/user-objection-events/request/logs/${this.$route.params.id}`);

                const data = result.data.content.data;

                this.dataset.logs = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadDynamicTexts() {

            try {
                const result = await axios.get(`/api/admin/dynamic-texts`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.dynamicTexts = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                description: this.dataset.data.description,
                client: this.dataset.data.client,
                unit: this.dataset.data.unit,
                associations: this.normalizeAssociations(),
                credential: {
                    username: this.dataset.data.email,
                    password: this.dataset.data.password,
                },
                roles: this.dataset.data.roles

            }

            return data;
        },

        async statusReset(eventContext = this.dataset.data) {

            const eventId = eventContext && eventContext.id ? eventContext.id : this.$route.params.id;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja restaurar o pedido?',
                title: 'Restaurar',
                actions: {
                    false: 'Cancelar',
                    true: 'Restaurar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.patch(`/api/admin/user-objection-events/restore/${eventId}`, { status: 0 });

                this.$dialog.notify.info('Pedido restaurado com sucesso!', { position: "top-right", timeout: 2000 });

                if (eventId === this.$route.params.id) {
                    this.goBack()
                } else {
                    await this.loadData();
                }

            } catch (error) {
                console.log("erro: ", error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        getCreditorTypeName(typeId) {
            const type = this.dataset.creditorTypes.find(item => item.id === typeId);
            return type ? type.name : 'N/A';
        },

        onAutocompleteChange(eventIndex) {
            this.$set(this.dataset.data.items[eventIndex], 'isChanged', true);
        },

        async updateClassType(eventItem, eventIndex) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar a classe do negócio?`,
                title: `Atualizar classe`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            const id = eventItem.id
            const type = eventItem.type

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/class-type-change/${id}`, { type: type })

                this.$dialog.notify.info(`Classe atualizada com sucesso!`, { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                })
            } finally {
                this.dataset.loading = false;
            }

            this.$set(this.dataset.data.items[eventIndex], 'isChanged', false);
        },

        async copyToClipboard(data) {
            await navigator.clipboard.writeText(data);

            this.$dialog.notify.info(`Copiado para área de transferência!`, { position: "top-right", timeout: 3000 });
        },

        viewUserEvent(item) {
            console.log('item ', item)
            this.$router.replace(`/divergencias/${item[0].id}`);
        },

        viewObjectionEventDetails(value) {
            window.location.href = `#/revisao-credito/${value.id}`;
            window.location.reload();
        },

        hasExternalDocuments(eventItem) {
            if (!eventItem || !eventItem.documents) return false;

            if (Array.isArray(eventItem.documents)) {
                return eventItem.documents.length > 0;
            }

            if (typeof eventItem.documents === 'string') {
                return eventItem.documents.trim().length > 0;
            }

            return false;
        },

        parsedDebtorDocuments(eventItem) {
            if (!eventItem || !eventItem.documents) return [];

            if (Array.isArray(eventItem.documents)) {
                return eventItem.documents.filter(Boolean);
            }

            if (typeof eventItem.documents === 'string') {
                try {
                    const parsed = JSON.parse(eventItem.documents);
                    if (Array.isArray(parsed)) return parsed.filter(Boolean);
                } catch (e) {

                    return eventItem.documents
                        .split(',')
                        .map(x => x.trim())
                        .filter(Boolean);
                }
            }

            return [];
        },

        async loadQgcAdjustedData() {
           try {
                const registration = this.dataset.data.user.registration;

                if (!registration) {
                    this.$dialog.notify.error('CPF/CNPJ do usuário não encontrado.', {
                        position: 'top-right',
                        timeout: 2000
                    });
                    return;
                }

                const cleanRegistration = registration
                    .replace(/\./g, '')
                    .replace(/-/g, '')
                    .replace(/\//g, '');

                const result = await axios.get( `/api/admin/users-creditors/qgc-creditor-adjusted-find`, { params: { registration: cleanRegistration } } );

                const data = result.data.content;
    
                this.dataset.data.qgcItems = data || [];

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        openQgcActionModal(qgcItem) {
            this.selectedQgcItem = qgcItem;
            this.qgcActionForm = { action_type: null, action_new_type: null, action_new_amount: null };
            this.dialogQgcAction = true;
        },

        openQgcActionInfo(qgcItem) {
            this.selectedQgcItem = qgcItem;
            this.dialogQgcActionInfo = true;
        },

        formatRegistration(registration) {
            if (!registration) return 'N/A';
            const clean = registration.replace(/\D/g, '');
            return clean.length <= 11 ? cpf.format(clean) : cnpj.format(clean);
        },

        async saveQgcAction() {
            if (!this.qgcActionForm.action_type) {
                this.$dialog.notify.error('Selecione o tipo de ação!', { position: 'top-right', timeout: 3000 });
                return;
            }
            if (this.qgcActionForm.action_type === 2 && !this.qgcActionForm.action_new_type) {
                this.$dialog.notify.error('Selecione a nova classe!', { position: 'top-right', timeout: 3000 });
                return;
            }
            if (this.qgcActionForm.action_type === 3 && !this.qgcActionForm.action_new_amount) {
                this.$dialog.notify.error('Informe o novo valor!', { position: 'top-right', timeout: 3000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja registrar a solicitação de alteração no QGC?',
                title: 'Confirmar solicitação',
                actions: { false: 'Cancelar', true: 'Confirmar' }
            });

            if (!proceedAction) return;

            const payload = {
                qgc_item_id: this.selectedQgcItem.id,
                action_type: this.qgcActionForm.action_type,
                action_new_type: this.qgcActionForm.action_new_type,
                action_new_amount: this.qgcActionForm.action_new_amount,
            };

            this.dataset.loading = true;

            try {
                await axios.post(`/api/admin/users-creditors/qgc-creditor-adjusted-action`, payload );

                this.$dialog.notify.info('Solicitação registrada com sucesso!', { position: 'top-right', timeout: 3000 });

                this.dialogQgcAction = false;

                await this.loadData();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 3000 });
            } finally {
                this.dataset.loading = false;
            }
        },

    },

};

</script>

<style lang="scss">
.checkbox-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    /* Certifique-se de que o checkbox esteja acima do painel */
    pointer-events: auto;
    transform: translateY(+3%);
    /* Garante clicabilidade */
}

.checkbox-marked-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    /* Certifique-se de que o checkbox esteja acima do painel */
    pointer-events: auto;
    /* Garante clicabilidade */
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    /* Altura mínima para manter consistência visual */
    text-align: center;
    color: #4caf50;
    /* Cor do texto combinando com o indicador */
}

.v-expansion-panel-header {
    position: relative;
    padding-left: 40px;
    /* Ajusta o espaço para o checkbox */
}

.centered {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 15px;
}

.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.custom-editor-short {
    .tiptap-vuetify-editor__content {
        min-height: 100px !important;
    }

    .ProseMirror {
        min-height: 100px !important;
    }
}

.custom-editor-long {
    .tiptap-vuetify-editor__content {
        min-height: 200px !important;
    }

    .ProseMirror {
        min-height: 200px !important;
    }
}

.icon-container {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 8px;
}

.image-resizer {
    display: inline-flex;
    position: relative;
    flex-grow: 0;
}

.image-resizer .resize-trigger {
    position: absolute;
    right: -6px;
    bottom: -9px;
    opacity: 0;
    transition: opacity .3s ease;
    color: #3259a5;
}

.image-resizer:hover .resize-trigger {
    opacity: 1;
}

.char-counter {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
}

.text-red {
    color: red;
}

.caption-text {
    font-size: 12px;
    font-weight: bold;
    color: #444;
    margin-top: 15px;
}

.document-container {
    position: relative;
    width: 250px;
    height: 150px;
}

.overlay-link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.document-frame {
    width: 250px;
    height: 150px;
    border: none;
    overflow: hidden;
    scrolling: no;
}

.v-chips-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    margin-bottom: 5px;
}

.v-text-field .v-input__control {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.v-text-field .v-input__control>.v-chips-container {
    margin-right: auto;
}

.card-title {
    border-bottom: 4px solid #2373c9 !important;
    padding-bottom: 8px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    // font-family: 'Raleway' !important;
    font-weight: 650 !important;
    font-size: 20px !important;
    font-style: bold !important;
    text-align: center !important;
}

.div-comments p {
    margin-bottom: 0px !important;
}

.doc-active-class {
    border: 2px solid #e74c3c;
    /* Vermelho bonito */
    border-radius: 12px;
    /* Arredondado para suavidade */
    box-shadow: 0 4px 8px rgba(231, 76, 60, 0.4);
    /* Sombra suave */
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    /* Efeito de interação */
}

.doc-inactive-class {
    border: 0px;
    border-radius: 12px;
    box-shadow: none !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
</style>